import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Select,
  DatePicker,
  GET,
  POST,
  PUT,
  UPLOAD,
  t,
  can,
} from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";
// ประเภทประกาศ / ทิศ / สิ่งอำนวยความสะดวก / แท็ก / จุดสนใจใกล้เคียง ใช้ชุดกลางร่วมกับ
// หน้ารวมทรัพย์ ส่วนประเภททรัพย์เป็นข้อมูล master ในฐานข้อมูล จึงดึงจาก API มาเก็บใน state
import {
  DEALS,
  DIRECTIONS,
  AMENITIES,
  DECORATIONS,
  FURNISH_OPTIONS,
  decorationMeta,
  furnishMeta,
  FACILITIES,
  TAGS,
  NEARBY_TYPES,
  PROPERTY_STATUS,
  PARKING_TYPES,
  parkingTypes,
  parkingCount,
  CONTRACT_TERMS,
  CONTRACT_UNITS,
  contractUnitMeta,
  statusMeta,
  isLandType,
  isHouseType,
} from "../../components/asset_option.js";
// ค่าคงที่ของแผนที่ + ตัวจับคู่ชื่อทำเลไทย ใช้ร่วมกับหน้า "โครงการ" (page/admin/projects.js)
// ซึ่งกรอกตำแหน่งที่ตั้งชุดเดียวกันเป๊ะ — อยู่ที่เดียวกันไว้จะได้ไม่เพี้ยนคนละแบบ
import {
  MAP_KEY,
  MAP_LIBRARIES,
  MAP_CENTER_DEFAULT,
  MAP_CONTAINER_STYLE,
  MAP_OPTIONS,
  reverseGeocode,
  zoneOptions,
  nearestStations,
  coord,
} from "../../components/location_option.js";
/* ตัวช่วยฝั่ง "ข้อมูลโครงการ" — ใช้ชุดเดียวกับหน้า "โครงการ" (page/admin/projects.js)
   เพราะทั้งสองหน้าต้องตัดสินเรื่องเดียวกัน : สถานที่ที่ค้นจากแผนที่มีในโครงการแล้วหรือยัง */
import { normalizeName, findProjectByName, projectLocationBody } from "../../components/project_option.js";
import PlaceSearch from "../../components/PlaceSearch.js";
import { GoogleMap, LoadScriptNext, Marker } from "@react-google-maps/api";
import LANG_TH from "../../components/language/th.json";
import LANG_EN from "../../components/language/en.json";
import "../../assets/css/property.css";
import "../../assets/css/property_form.css";

/* ============================================================================
 * จัดการทรัพย์ › เพิ่มทรัพย์ (/ad/assets/create) และแก้ไขทรัพย์ (/ad/assets/:uid/edit)
 * ฟอร์มลงทรัพย์แบบ 5 ขั้นตอน
 *   1) ข้อมูลทรัพย์      — ประเภทประกาศ / ประเภททรัพย์ / โครงการ / ตำแหน่งที่ตั้ง
 *   2) รูปภาพ / วิดีโอ   — อัปโหลดรูป เลือกรูปปก ลิงก์วิดีโอและทัวร์ 360°
 *   3) รายละเอียด        — ชื่อประกาศ สเปกห้อง ราคา และสิ่งอำนวยความสะดวก
 *   4) ข้อมูลภายใน       — เจ้าของทรัพย์ ค่าคอมฯ โน้ตภายใน (ไม่แสดงหน้าเว็บ)
 *   5) Preview & Publish — ตรวจความครบถ้วนแล้วเผยแพร่
 *
 * ต่อกับ API แล้ว :
 *   GET  admin/asset-categories     (ประเภททรัพย์ — ข้อมูล master เก็บเป็น id ที่ฝั่ง API)
 *   GET  admin/projects             (โครงการ — เลือกแล้วเติมตำแหน่งที่ตั้งให้อัตโนมัติ)
 *   GET  admin/assets/next-code     (รหัสทรัพย์ถัดไปของประเภทที่เลือก — โชว์ในฟอร์มเท่านั้น
 *                                    รหัสจริงฝั่ง API ออกให้ตอนบันทึก : KEY-ปีเดือน-เลขรัน 5 หลัก)
 *   GET  admin/assets/:uid          (โหมดแก้ไข)
 *   POST admin/assets               (สร้าง)
 *   PUT  admin/assets/:uid          (แก้ไข)
 *
 * ไฟล์ที่เลือกจากเครื่องจะถูกอัปโหลดขึ้น R2 ทีละไฟล์ตอนกดบันทึก (UPLOAD) แล้วส่งไป
 * เฉพาะ URL — ไม่ยัด base64 ไปกับ body ของประกาศ
 * ========================================================================== */

/* ------------------------------------------------------------- ขั้นตอนทั้งหมด */
const STEPS = [
  { no: 1, label: "step_property_info" },
  { no: 2, label: "step_media" },
  { no: 3, label: "step_details" },
  { no: 4, label: "step_internal" },
  { no: 5, label: "step_preview" },
];

/* โครงการ — ข้อมูล master จากเมนู "จัดการทรัพย์ › โครงการ" (GET admin/projects)
   เลือกโครงการแล้วฟอร์มจะเติมตำแหน่งที่ตั้งของโครงการนั้นให้ทั้งชุด (setProject) */

/* ---------------------------------------------------- แผนที่ / ตำแหน่งที่ตั้ง
 * ทำเล (จังหวัด › เขต/อำเภอ › แขวง/ตำบล › รหัสไปรษณีย์) อ่านจาก th_province.json
 * ค่าคงที่ของแผนที่และตัวจับคู่ชื่อย้ายไปอยู่ที่ components/location_option.js แล้ว
 * เพราะหน้า "โครงการ" ใช้ชุดเดียวกัน
 * ------------------------------------------------------------------------- */

/* ----------------------------------------------- จุดสนใจใกล้เคียง (ขั้นที่ 1)
 * ชุดประเภท (NEARBY_TYPES) อยู่ใน asset_option.js เพราะโมดัลรายละเอียดในหน้ารวมทรัพย์
 * ต้องใช้ไอคอน/ชื่อชุดเดียวกัน ส่วนตัวหาสถานีรถไฟฟ้าที่ใกล้ที่สุด (nearestStations)
 * อยู่ใน location_option.js เพราะหน้า "โครงการ" ใช้ปุ่มเดียวกันนี้ด้วย
 * ------------------------------------------------------------------------- */

/* ภาษาของรายละเอียดประกาศ — 1 แท็บต่อ 1 ภาษา */
const DESC_LANGS = [
    { value: "th", label: "lang_thai", field: "description_th" },
    { value: "en", label: "lang_english", field: "description_en" },
    { value: "cn", label: "lang_chinese", field: "description_cn" },
];

/* รูปภาพ — จำกัดจำนวนไฟล์ต่อ 1 ประกาศ */
const MAX_PHOTOS = 20;

/* ช่องทางวิดีโอ / ลิงก์ที่รองรับ (โลโก้วาดเป็น SVG เพราะฟอนต์ไอคอนของโปรเจกต์
   เป็น fa-light ซึ่งไม่มีชุด brand) */
const VIDEO_PROVIDERS = [
    { value: "youtube", label: "YouTube", placeholder: "https://www.youtube.com/watch?v=xxxxxxxxxxx" },
    { value: "tiktok", label: "TikTok", placeholder: "https://www.tiktok.com/@safespacelifeliving/video/xxxxxxxxxxx" },
    { value: "facebook", label: "Facebook Reel", placeholder: "https://www.facebook.com/reel/xxxxxxxxxxx" },
    { value: "drive", label: "Google Drive", placeholder: "https://drive.google.com/file/d/xxxxxxxxxxx/view" },
    { value: "matterport", label: "Matterport", placeholder: "https://my.matterport.com/show/?m=xxxxxxxxxxx" },
];

const BrandIcon = ({ provider }) => {
    switch (provider) {
        case "youtube":
            return (
                <svg viewBox="0 0 576 512" width="18" height="18" aria-hidden="true">
                    <path
                        fill="#FF0000"
                        d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6C14.9 167 14.9 256.4 14.9 256.4s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.1 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3z"
                    />
                    <path fill="#fff" d="M232.1 337.6V175.2l142.8 81.2-142.8 81.2z" />
                </svg>
            );
        case "tiktok":
            return (
                <svg viewBox="0 0 448 512" width="16" height="16" aria-hidden="true">
                    <path
                        fill="#111"
                        d="M448 209.9a210.1 210.1 0 0 1-122.8-39.3v178.7A162.6 162.6 0 1 1 185 188.3v89.9a74.6 74.6 0 1 0 52.2 71.2V0h88a121.2 121.2 0 0 0 1.9 22.2 122.2 122.2 0 0 0 53.9 80.2 121.4 121.4 0 0 0 67 20.1z"
                    />
                </svg>
            );
        case "facebook":
            return (
                <svg viewBox="0 0 320 512" width="16" height="16" aria-hidden="true">
                    <path
                        fill="#1877F2"
                        d="M279.1 288l14.2-92.7h-88.9v-60.1c0-25.4 12.4-50.1 52.2-50.1h40.4V6.3S260.4 0 225.4 0c-73.2 0-121.1 44.4-121.1 124.7v70.6H22.9V288h81.4v224h100.2V288z"
                    />
                </svg>
            );
        case "drive":
            return (
                <svg viewBox="0 0 87.3 78" width="18" height="18" aria-hidden="true">
                    <path fill="#0066da" d="m6.6 66.9 3.9 6.6c.8 1.4 2 2.5 3.3 3.3l13.7-23.8H0c0 1.6.4 3.1 1.2 4.5z" />
                    <path fill="#00ac47" d="M43.6 25 29.9 1.2c-1.4.8-2.5 1.9-3.3 3.3l-25.4 44A9 9 0 0 0 0 53h27.5z" />
                    <path fill="#ea4335" d="M73.6 76.8c1.3-.8 2.5-1.9 3.3-3.3l1.6-2.8L86 57.9c.8-1.4 1.2-3 1.2-4.5H59.8l5.8 11.5z" />
                    <path fill="#00832d" d="M43.6 25 57.4 1.2C56 .4 54.5 0 52.9 0H34.4c-1.6 0-3.2.5-4.5 1.2z" />
                    <path fill="#2684fc" d="M59.8 53.3H27.5L13.7 77.2c1.4.8 2.9 1.2 4.5 1.2h50.9c1.6 0 3.1-.5 4.5-1.2z" />
                    <path fill="#ffba00" d="m73.4 26.5-12.7-22c-.8-1.4-2-2.5-3.3-3.3L43.6 25l16.2 28.3h27.4c0-1.5-.4-3.1-1.2-4.5z" />
                </svg>
            );
        default:
            return (
                <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true">
                    <path fill="#111" d="M2.5 21V3h4.2l5.3 7.4L17.3 3h4.2v18h-4.1V10l-5.4 7.3L6.6 10v11z" />
                </svg>
            );
    }
};

/* ตัวเลือกการเผยแพร่ (ขั้นที่ 5) — ชื่อปุ่มบันทึกและข้อความยืนยันเปลี่ยนตามตัวเลือกที่เลือก */
const PUBLISH_MODES = [
    { value: "publish", title: "publish_now", desc: "publish_now_desc", icon: "", action: "publish_property", confirm: "publish_confirm", note: "publish_note_now", done: "publish_done" },
    { value: "schedule", title: "publish_schedule", desc: "publish_schedule_desc", icon: "", action: "publish_schedule", confirm: "schedule_confirm", note: "publish_note_schedule", done: "schedule_done" },
    { value: "draft", title: "publish_draft", desc: "publish_draft_desc", icon: "", action: "publish_draft", confirm: "draft_confirm", note: "publish_note_draft", done: "draft_saved" },
];
const publishMode = (d) => PUBLISH_MODES.find((e) => e.value === d.publish_mode) || PUBLISH_MODES[0];

/* สถานะการเผยแพร่ที่ API เก็บไว้ → ตัวเลือกในฟอร์ม */
const PUBLISH_STATUS_MODE = { published: "publish", scheduled: "schedule", draft: "draft" };

/* เวลาที่ให้เลือกตอนตั้งเวลาเผยแพร่ (ทุกครึ่งชั่วโมงในช่วงเวลาทำการ) */
const PUBLISH_TIMES = ["08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"];

/* ความยาวเส้นรอบวงของวงแหวนความคืบหน้า (r = 34) */
const RING_LENGTH = 2 * Math.PI * 34;

/* ตำแหน่งที่ตั้งทั้งชุด (ค่าว่าง) — แยกออกมาเพราะต้องล้างยกชุดตอนสลับ/ยกเลิกโครงการ
 * ทุกช่องในนี้ผูกกับโครงการที่เลือกทั้งหมด เพิ่มช่องใหม่ต้องเพิ่มตรงนี้ที่เดียว
 * ------------------------------------------------------------------------- */
const EMPTY_LOCATION = {
  place_search: "",
  province: "",
  district: "",
  subdistrict: "",
  soi: "",
  postcode: "",
  latitude: "",
  longitude: "",
  nearby: [],
};

/* ------------------------------------------------- ค่าตั้งต้นของฟอร์ม (ฟอร์มเปล่า)
 * ทุกช่องว่างหมด เหลือไว้เฉพาะค่าที่ระบบเลือกให้ล่วงหน้าอยู่แล้ว (ประเภทประกาศ
 * ประเภททรัพย์ ช่องทางวิดีโอ และตัวเลือกการเผยแพร่)
 * ------------------------------------------------------------------------- */
const EMPTY_DATA = {
  /* ขั้นที่ 1 */
  deals: ["rent"],
  type: "condo",
  headline: "",    // หัวข้อประกาศที่ตั้งเอง (ว่าง = ใช้ชื่อโครงการเป็นชื่อประกาศ)
  project_uid: "", // โครงการจากเมนู master (ว่าง = ไม่ผูกโครงการ)
  project: "",     // ชื่อโครงการ — ตามโครงการที่เลือก ใช้ประกอบชื่อประกาศ
  keywords: [],
  ...EMPTY_LOCATION,

  /* ขั้นที่ 2 */
  photos: [],
  cover: "",
  video_provider: "youtube",
  video_url: "",
  floor_plans: [],

  /* ขั้นที่ 3 */
  code: "",
  area: "",
  land_area: "",
  floor: "",
  floor_count: "", // จำนวนชั้นของตัวบ้าน — เฉพาะประเภทแนวราบ
  bedroom: "",
  bathroom: "",
  living_room: "",
  kitchen: "",
  // ที่จอดรถ — ติ๊กประเภทที่จอดได้ (ติ๊กพร้อมกันได้ทั้งคู่) แล้วระบุจำนวนคันต่อแบบได้ (ไม่บังคับ)
  parking_motorcycle: false,
  parking_car: false,
  parking_motorcycle_count: "",
  parking_car_count: "",
  building: "",
  direction: "",
  built_year: "",
  rent: "",
  // ระยะสัญญาเช่า — ยังไม่ระบุ = ว่าง ส่วนหน่วยตั้งต้นเป็นเดือนตามที่ใช้กันจริง
  contract_term: "",
  contract_unit: "month",
  price: "",
  deposit: "",
  advance_use: true,
  advance_month: "1",
  move_in_payment: "",
  common_fee: "",              // ค่าส่วนกลางต่อเดือน (บาท)
  common_fee_included: false,  // ค่าเช่าที่ประกาศไว้รวมค่าส่วนกลางแล้วหรือยัง
  special_terms: "",           // เงื่อนไขพิเศษของประกาศ
  co_agent_use: true, // ไม่ติดโค → ซ่อนช่องสัดส่วน/ผู้ติดต่อ และล้างค่าทิ้ง
  amenities: [],
  amenity_other: "",
  // การตกแต่ง / เฟอร์นิเจอร์ — เลือกได้อย่างละค่าเดียว ว่าง = ยังไม่ระบุ
  decoration: "",
  furnished: "",
  // ส่วนกลางของโครงการ + ช่อง "อื่น ๆ ระบุ"
  facilities: [],
  facility_other: "",
  pet_allowed: false,
  tags: [],
  description_th: "",
  description_en: "",
  description_cn: "",
  available_at: "",

  /* ขั้นที่ 4 */
  owner_name: "",
  owner_phone: "",
  owner_line: "",
  owner_facebook: "",
  owner_email: "",
  owner_overseas: false,
  water_fee: "",
  common_fee_month: "",
  co_agent_share: "",
  co_agent_name: "",
  co_agent_phone: "",
  documents: [],
  internal_note: "",
  // ผู้ดูแลไม่มีช่องแก้ในฟอร์ม (ระบบกำหนดจากผู้สร้างประกาศ) ส่วนสถานะเลือกได้ที่ขั้นที่ 4
  admin_uid: "",
  status: "available",

  /* ขั้นที่ 5 */
  publish_mode: "publish",
  publish_at: "",
  publish_time: "09:00",
};

/* ------------------------------------------- คำศัพท์สำหรับข้อความ AI ร่างให้
 * t() อิงภาษาที่ผู้ใช้ตั้งไว้ในระบบ แต่ปุ่ม "AI ช่วยเขียน" ต้องได้ภาษาตามแท็บที่เปิดอยู่
 * จึงอ่านคำจากไฟล์แปลตรง ๆ ส่วนภาษาจีนยังไม่มีไฟล์แปล ใช้ตารางคำเฉพาะด้านล่างแทน
 * ------------------------------------------------------------------------- */
const CN_TERMS = {
  type_condo: "公寓",
  type_house: "独栋别墅",
  type_townhouse: "联排别墅",
  type_townhome: "城市住宅",
  type_twin_house: "双拼别墅",
  type_home_office: "商住两用",
  type_commercial: "商业楼",
  type_warehouse: "仓库",
  type_land: "土地",
  type_new_project: "新项目",
  bedroom: "卧室",
  bathroom: "卫生间",
  living_room: "客厅",
  kitchen: "厨房",
  parking_motorcycle: "摩托车位",
  parking_car: "汽车车位",
  floor_label: "楼层",
  floor_count: "楼层数",
  sqm: "平方米",
  sqw: "平方哇",
  baht_per_month: "泰铢 / 月",
  unit_baht: "泰铢",
  tag_pet: "可养宠物",
  tag_smoking: "可吸烟",
  tag_corner: "边角户",
  tag_city_view: "城市景观",
  tag_near_mrt: "近地铁 MRT",
  tag_near_bts: "近轻轨 BTS",
  tag_near_university: "近大学",
  tag_ready: "拎包入住",
  tag_renovated: "全新翻新",
  tag_new_building: "新楼盘",
  tag_built_in: "全屋定制家具",
  tag_duplex: "复式",
  tag_penthouse: "顶层豪宅",
  tag_many_parking: "多车位",
  tag_pool_view: "泳池景观",
  tag_invest: "适合投资",
  amenity_washer: "洗衣机",
  amenity_wifi: "Wi-Fi / 网络",
  amenity_fridge: "冰箱",
  amenity_doorlock: "智能门锁",
  amenity_tv: "电视",
  amenity_smart_tv: "智能电视",
  amenity_microwave: "微波炉",
  amenity_oven: "烤箱",
  amenity_stove: "电磁炉",
  amenity_dishwasher: "洗碗机",
  amenity_hood: "抽油烟机",
  amenity_water_heater: "热水系统",
  amenity_aircon: "空调",
  amenity_dryer: "烘干机",
  amenity_water_purifier: "净水器",
  amenity_furnished: "家具齐全",
  amenity_bed: "床",
  amenity_wardrobe: "内置衣柜",
  amenity_dining_table: "餐桌椅",
  amenity_desk: "书桌",
  amenity_bathtub: "浴缸",
  amenity_balcony: "阳台",
  amenity_storage: "储藏室",
  amenity_other: "其他",
};
const term = (key, lang) => {
  if (lang === "cn") return CN_TERMS[key] || LANG_EN[key] || key;
  return (lang === "en" ? LANG_EN : LANG_TH)[key] || key;
};

/* ------------------------------------------------------------------ helpers */
const money = (v) => Number(String(v || 0).replace(/,/g, "") || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
const digits = (v) => /^[\d.]*$/.test(v);
/* ช่องจำนวนเงิน — เก็บใน state เป็นตัวเลขล้วน แต่แสดงคั่นหลักพันระหว่างพิมพ์ (12000 → 12,000)
   ทศนิยมที่ยังพิมพ์ไม่จบ (เช่น "12000.") ต้องคงไว้ ไม่งั้นจุดจะหายทันทีที่พิมพ์ */
const moneyInput = (v) => {
  const value = String(v ?? "");
  if (value === "") return "";
  const [int, ...rest] = value.split(".");
  const head = int === "" ? "" : Number(int).toLocaleString("en-US");
  return rest.length ? `${head}.${rest.join("")}` : head;
};
const signedDigits = (v) => /^-?[\d.]*$/.test(v); // ละติจูด/ลองจิจูดติดลบได้
const isRentDeal = (deals) => (deals || []).includes("rent");
const isSaleDeal = (deals) => (deals || []).includes("sale");

/* สิ่งอำนวยความสะดวกที่ปุ่ม "เลือกทั้งหมด" ติ๊กให้ — ไม่รวม "อื่น ๆ"
   เพราะข้อนั้นต้องพิมพ์ข้อความต่อเอง ติ๊กให้เฉย ๆ จะได้ช่องเปล่าติดไปกับประกาศ */
const BULK_AMENITIES = AMENITIES.filter((item) => item.value !== "other").map((item) => item.value);
const hasAllAmenities = (amenities) => BULK_AMENITIES.every((value) => (amenities || []).includes(value));
// ชื่อประเภททรัพย์มาจากฐานข้อมูล ไม่ได้อยู่ในไฟล์แปล จึงเลือกภาษาเองตามที่ผู้ใช้ตั้งไว้
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const categoryName = (category) => (category ? (isTh() ? category.name_th : category.name_en || category.name_th) : "");

// ค่าจาก API เป็นตัวเลข/null แต่ช่อง input ต้องได้สตริงเสมอ ไม่งั้น React จะเปลี่ยนเป็น uncontrolled
const str = (value) => (value === null || value === undefined ? "" : String(value));

// ชื่อประกาศสร้างอัตโนมัติจากข้อมูลที่กรอก
// ตั้งหัวข้อไว้ = ใช้หัวข้อตรง ๆ  ไม่ได้ตั้งแต่ผูกโครงการ = ใช้ชื่อโครงการ
// ไม่มีทั้งคู่ = ประกอบจากประเภททรัพย์ + ห้องนอน + ชั้น
const listingTitle = (d, typeName) => {
  const headline = String(d.headline || "").trim();
  if (headline) return headline;
  const project = String(d.project || "").trim();
  if (project) return project;
  const parts = [typeName];
  if (Number(d.bedroom)) parts.push(`${d.bedroom} ${t("bedroom")}`);
  if (Number(d.floor)) parts.push(`${t("floor_label")} ${d.floor}`);
  return parts.filter(Boolean).join(" · ");
};

// เงื่อนไขพิเศษ — ความยาวต้องตรงกับ DTO ฝั่ง API (special_terms max 200)
const MAX_SPECIAL_TERMS = 200;

/* ไฟล์อัปโหลด — จำกัดขนาดต่อไฟล์ และแปลง byte เป็นข้อความที่คนอ่านเข้าใจ */
const MAX_FILE_MB = 10;
const fileSize = (bytes) =>
  bytes >= 1048576 ? `${(bytes / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;
const isImageFile = (file) => (file.type || "").startsWith("image/");
const isPlanFile = (file) => isImageFile(file) || file.type === "application/pdf" || /\.pdf$/i.test(file.name);
// ลากไฟล์จากเครื่องเข้ามา (ไม่ใช่การลากสลับลำดับรูปภายในหน้า)
const hasFiles = (event) => Array.from(event.dataTransfer?.types || []).includes("Files");

class PropertyCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            data: { ...EMPTY_DATA },
            keyword: "", // ช่องพิมพ์คีย์เวิร์ดใหม่ (แสดงเมื่อกด "เพิ่มคีย์เวิร์ด")
            keyword_open: false,
            // Google Maps JS API โหลดเสร็จหรือยัง (ใช้ตัดสินใจว่าเรียก Geocoder ได้ไหม)
            // ถ้าเคยโหลดไว้แล้วจากการเข้าขั้นตอนนี้รอบก่อน จะพร้อมใช้งานทันที
            map_ready: !!window.google?.maps,
            drag_photo: "", // uid ของรูปที่กำลังลาก (ลากสลับลำดับภายในหน้า)
            over_photo: "", // uid ของรูปที่ถูกลากมาวางทับ
            photo_drop: false, // กำลังลากไฟล์รูปจากเครื่องมาวางบนแกลเลอรี
            plan_drop: false, // กำลังลากไฟล์มาวางบนกล่องอัปโหลดแผนผังห้อง
            doc_drop: false, // กำลังลากไฟล์มาวางบนรายการเอกสารประกอบ
            desc_lang: "th", // แท็บภาษาของรายละเอียดประกาศ
            tag_open: false, // เปิดช่องพิมพ์แท็กใหม่
            tag_input: "",
            preview_photo: "", // รูปที่เลือกดูในกรอบพรีวิว (ว่าง = ใช้รูปปก)
            preview_device: "desktop", // ดูพรีวิวแบบเดสก์ท็อป / มือถือ
            preview_lang: "th", // ภาษาของรายละเอียดที่โชว์ในพรีวิว
            summary_tab: "listing", // แท็บสรุป : ข้อมูลประกาศ / ข้อมูลภายใน
            categories: [], // ประเภททรัพย์ (ข้อมูล master จาก API)
            projects: [], // โครงการ (ข้อมูล master จาก API — พร้อมตำแหน่งที่ตั้งของแต่ละโครงการ)
            /* งานข้อมูลโครงการที่ค้างไว้ให้ทำตอนกดบันทึก — ตั้งค่าโดย MatchProject ตอนค้นหาจากแผนที่
               { mode: "create" | "update", uid, name, categories } (null = ไม่ต้องแตะข้อมูลโครงการ) */
            project_sync: null,
        };
        // ไม่มี uid บน route = กำลังสร้างทรัพย์ใหม่ (เดินตามขั้นตอนทีละขั้น ข้ามไม่ได้)
        // มี uid (/ad/assets/:uid/edit) = โหมดแก้ไข กระโดดข้ามขั้นตอนได้
        this.uid = props.router?.params?.uid || "";
        this.is_create = !this.uid;
        // input file ที่ซ่อนไว้ — ให้ปุ่ม/ไทล์บนหน้าเป็นตัวเปิดหน้าต่างเลือกไฟล์แทน
        this.photo_input = React.createRef();
        this.plan_input = React.createRef();
        this.doc_input = React.createRef();
    }

    componentDidMount() {
        loading(false);
        window.scrollTo({ top: 0 });
        this.GetMaster();
        if (!this.is_create) this.Get();
    }

    /* ประเภททรัพย์ / โครงการ — ตัวเลือกของฟอร์ม
       โครงการดึงมาทั้งก้อน (ไม่ใช่แค่ชื่อ) เพราะต้องใช้ตำแหน่งที่ตั้งของโครงการไปเติมให้ฟอร์ม
       ตอนเพิ่มทรัพย์ใหม่ขอรหัสทรัพย์ถัดไปของประเภทที่เลือกมาโชว์ให้ดู (แก้เองไม่ได้) */
    GetMaster = async () => {
        const [categories, projects] = await Promise.all([
            GET("admin/asset-categories", { page: 0, is_active: true }),
            GET("admin/projects", { page: 0, is_active: true }),
        ]);

        const list = categories?.status ? categories.data || [] : [];

        this.setState(
            {
                categories: list,
                projects: projects?.status ? projects.data || [] : [],
            },
            // ฟอร์มเปล่าเริ่มที่ประเภทแรกของรายการ จะได้ไม่ค้างที่ประเภทที่ถูกปิดใช้งานไปแล้ว
            () => {
                if (!this.is_create) return;

                const current = this.state.data.type;
                const type = list.some((e) => e.code === current) ? current : list[0]?.code || "";
                if (type !== current) this.set({ type });

                // รหัสทรัพย์ผูกกับ KEY ของประเภท จึงต้องรู้ประเภทก่อนถึงจะขอรหัสมาโชว์ได้
                this.GetNextCode(type);
            }
        );
    };

    /* KEY ของประเภทที่เลือก — ตั้งที่เมนู จัดการทรัพย์ › ประเภททรัพย์ ไม่มีค่าตั้งต้นให้
       ประเภทที่ยังไม่ได้ตั้ง KEY จะออกรหัสทรัพย์ไม่ได้ */
    typePrefix = (type) => (this.state.categories.find((e) => e.code === (type || this.state.data.type)) || {}).prefix || "";

    /* รหัสทรัพย์ถัดไปของประเภทที่เลือก — โชว์ในฟอร์มเฉย ๆ
       ค่าจริงฝั่ง API ออกให้ตอนบันทึก จึงไม่ต้องกลัวว่าเลขที่โชว์ค้างไว้จะถูกคนอื่นใช้ไปก่อน */
    GetNextCode = async (type) => {
        const key = type || this.state.data.type;
        if (!key) return;

        // ไม่มี KEY = ออกรหัสให้ไม่ได้ บอกตั้งแต่ตอนนี้ ดีกว่าให้กรอกจนจบแล้วค่อยบันทึกไม่ผ่าน
        if (!this.typePrefix(key)) {
            this.set({ code: "" });
            alert("", "warning", t("warning"), t("verify_type_prefix"));
            return;
        }

        const next = await GET("admin/assets/next-code", { type: key });
        if (next?.status) this.set({ code: next.data.code });
    };

    /* ประเภททรัพย์ที่เลือกอยู่ — ใช้ทั้งชื่อ ไอคอน และสีการ์ดในหน้าพรีวิว */
    category = () => this.state.categories.find((e) => e.code === this.state.data.type) || {};

    typeName = () => categoryName(this.category());

    // ชื่อประเภทตามภาษาของแท็บที่เปิดอยู่ (ฐานข้อมูลมีไทย/อังกฤษ ภาษาจีนใช้ตารางคำด้านบน)
    typeTerm = (lang) => {
        const category = this.category();
        if (lang === "cn") return CN_TERMS[`type_${category.code}`] || category.name_en || category.name_th || "";
        if (lang === "en") return category.name_en || category.name_th || "";
        return category.name_th || "";
    };

    /* ------------------------------------------------- โหลดข้อมูลเดิม (โหมดแก้ไข) */
    Get = async () => {
        loading(true);
        const result = await GET("admin/assets/" + this.uid, null);
        loading(false);

        // โหลดไม่สำเร็จ — GET เด้งข้อความบอกสาเหตุให้แล้ว จึงอยู่หน้าเดิมไว้เฉย ๆ
        // (ห้ามเด้งกลับหน้ารวมตรงนี้ เพราะจะเป็นการเปลี่ยนหน้าทั้งที่ป๊อปอัปยังเปิดค้างอยู่
        //  แล้ว alert() จะบล็อกป๊อปอัปตัวถัดไปทั้งหมด ทำให้ปุ่มบนหน้าใหม่กดแล้วเหมือนไม่ทำงาน)
        if (!result?.status) return;

        this.setState({ data: this.toForm(result.data) });
    };

    /* แปลงข้อมูลจาก API เป็นค่าของฟอร์ม
       กาง EMPTY_DATA ทับก่อนเสมอ กันฟิลด์ที่ API ไม่ได้ส่งมาเป็น undefined */
    toForm = (item) => ({
        ...EMPTY_DATA,

        deals: item.deals?.length ? item.deals : ["rent"],
        type: item.type || EMPTY_DATA.type,
        headline: item.headline || "",
        project_uid: item.project_uid || "",
        project: item.project || "",
        keywords: item.keywords || [],
        place_search: item.project || "",
        province: item.province || "",
        district: item.district || "",
        subdistrict: item.subdistrict || "",
        soi: item.soi || "",
        postcode: item.postcode || "",
        latitude: str(item.latitude),
        longitude: str(item.longitude),
        nearby: (item.nearby || []).map((e) => ({ type: e.type || "other", label: e.label || "", distance: str(e.distance) })),

        photos: (item.photos || []).map(this.toFormFile),
        cover: item.cover || "",
        video_provider: item.video_provider || EMPTY_DATA.video_provider,
        video_url: item.video_url || "",
        floor_plans: (item.floor_plans || []).map(this.toFormFile),

        code: item.code || "",
        area: str(item.area),
        land_area: str(item.land_area),
        floor: str(item.floor),
        floor_count: str(item.floor_count),
        bedroom: str(item.bedroom),
        bathroom: str(item.bathroom),
        living_room: str(item.living_room),
        kitchen: str(item.kitchen),
        parking_motorcycle: !!item.parking_motorcycle,
        parking_car: !!item.parking_car,
        parking_motorcycle_count: str(item.parking_motorcycle_count),
        parking_car_count: str(item.parking_car_count),
        building: item.building || "",
        direction: item.direction || "",
        built_year: str(item.built_year),
        rent: str(item.rent),
        contract_term: str(item.contract_term),
        contract_unit: item.contract_unit || EMPTY_DATA.contract_unit,
        price: str(item.price),
        deposit: str(item.deposit),
        // เก็บค่าเช่าล่วงหน้า 0 เดือน = ไม่ใช้ (ตรงกับตัวเลือก "ไม่ใช้" ในฟอร์ม)
        advance_use: Number(item.advance_month) > 0,
        advance_month: str(item.advance_month ?? "0"),
        move_in_payment: str(item.move_in_payment),
        co_agent_use: item.co_agent_use !== false,
        amenities: item.amenities || [],
        amenity_other: item.amenity_other || "",
        decoration: item.decoration || "",
        furnished: item.furnished || "",
        facilities: item.facilities || [],
        facility_other: item.facility_other || "",
        pet_allowed: !!item.pet_allowed,
        tags: item.tags || [],
        description_th: item.description_th || "",
        description_en: item.description_en || "",
        description_cn: item.description_cn || "",
        available_at: item.available_at || "",

        owner_name: item.owner_name || "",
        owner_phone: item.owner_phone || "",
        owner_line: item.owner_line || "",
        owner_facebook: item.owner_facebook || "",
        owner_email: item.owner_email || "",
        owner_overseas: !!item.owner_overseas,
        water_fee: str(item.water_fee),
        common_fee_month: str(item.common_fee_month),
        common_fee: str(item.common_fee),
        common_fee_included: !!item.common_fee_included,
        special_terms: item.special_terms || "",
        co_agent_share: str(item.co_agent_share),
        co_agent_name: item.co_agent_name || "",
        co_agent_phone: item.co_agent_phone || "",
        documents: (item.documents || []).map(this.toFormFile),
        internal_note: item.internal_note || "",
        admin_uid: item.admin_uid || "",
        admin_name: item.admin_name || "",
        // ผ่าน statusMeta เพื่อให้ค่าเดิมที่เลิกใช้แล้วตกลงมาที่สถานะใหม่ที่ตรงความหมาย
        status: statusMeta(item.status).value,

        publish_mode: PUBLISH_STATUS_MODE[item.publish_status] || "draft",
        publish_at: item.publish_status === "scheduled" && item.published_at ? String(item.published_at).slice(0, 10) : "",
        publish_time: item.publish_status === "scheduled" && item.published_at ? new Date(item.published_at).toTimeString().slice(0, 5) : EMPTY_DATA.publish_time,
    });

    // ไฟล์ที่อยู่บนระบบแล้ว — ไม่มี field `file` จึงไม่ต้องอัปโหลดซ้ำตอนบันทึก
    toFormFile = (item) => ({
        uid: item.uid,
        name: item.file_name || "",
        size: fileSize(item.file_size || 0),
        type: item.file_type === "image" ? "image" : "pdf",
        url: item.file_path,
        mime_type: item.mime_type || "",
        file_size: item.file_size ?? null,
    });

    componentWillUnmount() {
        // คืนหน่วยความจำของ object URL ที่สร้างไว้ตอนพรีวิวไฟล์
        [...this.state.data.photos, ...this.state.data.floor_plans, ...this.state.data.documents].forEach(this.revoke);
    }

    /* ------------------------------------------------------------ จัดการฟอร์ม */
    set = (patch, done) => this.setState((prev) => ({ data: { ...prev.data, ...patch } }), done);

    /* set เวอร์ชันรอจนค่าเข้า state จริง — ใช้ตอนบันทึก ที่ต้องอ่านค่าที่เพิ่งตั้งไปต่อทันที
       (payload อ่านจาก this.state.data ตรง ๆ ถ้าไม่รอจะได้ค่าเก่ารอบก่อน setState) */
    setAsync = (patch) => new Promise((resolve) => this.set(patch, resolve));

    // ต้องเลือกอย่างน้อย 1 อย่าง — กดปิดอันสุดท้ายจะไม่มีผล (เตือนแทน)
    toggleDeal = (value) => {
        const deals = this.state.data.deals || [];
        if (deals.includes(value)) {
            if (deals.length === 1) {
                alert("", "warning", t("warning"), t("verify_listing_type"));
                return;
            }
            this.set({ deals: deals.filter((e) => e !== value) });
            return;
        }
        // เรียงตามลำดับใน DEALS เสมอ เพื่อให้การแสดงผลคงที่ (เช่า ก่อน ขาย)
        this.set({ deals: DEALS.filter((e) => deals.includes(e.value) || e.value === value).map((e) => e.value) });
    };

    /* ช่องขนาดทรัพย์ขึ้นกับประเภท
         ที่ดิน       = ขนาดที่ดิน (ตร.ว.) อย่างเดียว
         บ้านแนวราบ  = ขนาดที่ดิน + พื้นที่ใช้สอย + จำนวนชั้นของตัวบ้าน
         ที่เหลือ     = พื้นที่ใช้สอย (ตร.ม.) อย่างเดียว
       สลับประเภทแล้วต้องล้างช่องที่ไม่ได้ใช้ทิ้ง ไม่งั้นค่าเดิมจะค้างและถูกนับว่ากรอกครบ */
    setType = (type) => {
        if (isLandType(type)) this.set({ type, area: "", floor_count: "" });
        // แนวราบไม่มีชั้นที่ตั้งอยู่/ตึก — ล้างทิ้งพร้อมกับที่ซ่อนช่องในฟอร์ม
        else if (isHouseType(type)) this.set({ type, floor: "", building: "" });
        else this.set({ type, land_area: "", floor_count: "" });
        // รหัสทรัพย์ขึ้นต้นด้วย KEY ของประเภท เปลี่ยนประเภทแล้วรหัสที่โชว์ต้องเปลี่ยนตาม
        if (this.is_create) this.GetNextCode(type);
    };

    /* เลือกโครงการ → ล้างตำแหน่งที่ตั้งเดิมทิ้งทั้งชุด แล้วเติมของโครงการที่เลือกเข้าไปแทน
       ทรัพย์ทุกยูนิตในโครงการเดียวกันอยู่ทำเลเดียวกัน จึงไม่ต้องกรอกซ้ำ (แก้รายทรัพย์ทีหลังได้)
       ต้องล้างก่อนเสมอ ไม่ใช่เติมทับทีละช่อง เพราะสลับโครงการไปมาแล้วค่าของโครงการก่อนหน้า
       (ซอย/รหัสไปรษณีย์/พิกัด/จุดสนใจใกล้เคียง) จะค้างปนกับโครงการใหม่
       จุดสนใจใกล้เคียงก็ผูกกับทำเล จึงล้างไปพร้อมกัน แล้วเอาของโครงการใหม่มาแทน */
    /* ตัวเลือกโครงการ — เหลือเฉพาะโครงการที่มีประเภททรัพย์ตรงกับที่เลือกไว้ในขั้นนี้
       โครงการที่ยังไม่ได้ระบุประเภท (ข้อมูลเก่าก่อนมีฟีเจอร์นี้) ยังเลือกได้ทุกประเภท
       และโครงการที่ผูกอยู่แล้วต้องคงอยู่ในรายการเสมอ ไม่งั้นตอนเปิดแก้ไขทรัพย์ที่ประเภทกับ
       โครงการไม่ตรงกัน ช่องนี้จะโชว์เป็นว่างทั้งที่ยังผูกโครงการนั้นอยู่ */
    projectOptions = () => {
        const { type, project_uid } = this.state.data;

        return this.state.projects
            .filter((project) => {
                if (project.uid === project_uid) return true;
                const codes = (project.asset_categories || []).map((category) => category.code);
                return !codes.length || codes.includes(type);
            })
            .map((project) => ({ value: project.uid, label: project.name }));
    };

    setProject = (uid) => {
        const project = this.state.projects.find((e) => e.uid === uid);
        /* ผู้ใช้เลือกโครงการเองแล้ว = ทิ้งงานที่ค้างไว้จากการค้นหาแผนที่
           (ค่าในฟอร์มกำลังจะถูกแทนด้วยทำเลของโครงการที่เลือก จะเอาไปอัปเดตต่อก็ไม่ตรงความตั้งใจ) */
        if (this.state.project_sync) this.setState({ project_sync: null });

        // ไม่เลือกโครงการ (หรือกดล้าง) → ตำแหน่งที่ตั้งของโครงการเดิมต้องหายตามไปด้วย
        // ไม่งั้นทรัพย์ที่ตั้งใจกรอกทำเลเองจะได้ค่าโครงการเก่าติดไปแบบเงียบ ๆ
        if (!project) {
            this.set({ project_uid: "", project: "", ...EMPTY_LOCATION });
            return;
        }

        this.set({
            project_uid: project.uid,
            project: project.name,
            ...EMPTY_LOCATION,
            place_search: project.name,
            province: project.province || "",
            district: project.district || "",
            subdistrict: project.subdistrict || "",
            soi: project.soi || "",
            postcode: project.postcode || "",
            latitude: str(project.latitude),
            longitude: str(project.longitude),
            nearby: (project.nearby || [])
                .filter((e) => e.label)
                .map((e) => ({ type: e.type || "other", label: e.label, distance: str(e.distance) })),
        });
    };

    // เปลี่ยนจังหวัด/เขต/แขวง → ล้างค่าที่ผูกอยู่ระดับล่างลงไป แล้วเติมรหัสไปรษณีย์ให้
    setProvince = (province) => this.set({ province, district: "", subdistrict: "", postcode: "" });

    setDistrict = (district) => this.set({ district, subdistrict: "", postcode: "" });

    setSubdistrict = (subdistrict, option) => this.set({ subdistrict, postcode: option?.code ? String(option.code) : "" });

    /* --------------------------------------------------------------- แผนที่ */
    /* ต้องเป็นเมธอดของคลาส ห้ามส่ง arrow function ใหม่เข้าไปตรง prop onLoad
       เพราะ LoadScriptNext เรียก onLoad ผ่าน useEffect ที่มี onLoad เป็น dependency
       ถ้า identity เปลี่ยนทุก render มันจะเรียกซ้ำทุกครั้ง → setState → render →
       เรียกซ้ำ วนไม่จบจนได้ "Maximum update depth exceeded" แล้วหน้าค้าง
       (เช็ก map_ready ก่อนด้วย เพราะ class component ไม่ bail out ตอน setState ค่าเดิม) */
    MapLoaded = () => {
        if (!this.state.map_ready) this.setState({ map_ready: true });
    };

    // จุดที่ใช้วาง marker / center — อ่านจากช่องละติจูด-ลองจิจูดโดยตรง
    // คืน object เดิมตราบใดที่พิกัดไม่เปลี่ยน เพราะ GoogleMap จะ setCenter ใหม่ทุกครั้ง
    // ที่ prop center เปลี่ยน reference (ถ้าสร้างใหม่ทุก render แผนที่จะเด้งกลับตลอด)
    pinned = () => {
        const lat = coord(this.state.data.latitude);
        const lng = coord(this.state.data.longitude);
        if (lat === null || lng === null) return null;
        if (!this.pin_cache || this.pin_cache.lat !== lat || this.pin_cache.lng !== lng) this.pin_cache = { lat, lng };
        return this.pin_cache;
    };

    // คลิก (หรือลาก marker) บนแผนที่ → เติมพิกัดลงช่อง input แล้วดึงที่อยู่มาเติมให้
    PinMap = (event) => {
        const lat = event?.latLng?.lat();
        const lng = event?.latLng?.lng();
        if (lat === undefined || lng === undefined) return;
        this.set({ latitude: lat.toFixed(6), longitude: lng.toFixed(6) });
        this.FillAddress({ lat, lng });
    };

    /* reverse geocode : พิกัด → จังหวัด/เขต/แขวง/รหัสไปรษณีย์
       จับคู่กับ th_province.json เท่าที่ตรงกันได้ ส่วนที่ไม่ตรงจะคงค่าเดิมไว้ (ไม่ล้างของที่ผู้ใช้กรอกเอง)
       แต่ต้องบอกผู้ใช้ด้วย ไม่งั้นหมุดขยับแล้วช่องที่อยู่ไม่เปลี่ยน จะนึกว่าระบบค้าง */
    FillAddress = async (location) => {
        if (!this.state.map_ready || !window.google?.maps) return;

        const { zone, error } = await reverseGeocode(location);
        if (error) return alert("", "warning", t("warning"), t(error));
        if (!zone) return alert("", "warning", t("warning"), t("address_out_of_range"));

        this.set(zone);
    };

    /* เลือกสถานที่จากรายการแนะนำ → ย้ายหมุด + เติมทำเลรวดเดียว
       Places คืน addressComponents มาให้อยู่แล้ว จึงไม่ต้องยิง Geocoding ซ้ำ */
    PickPlace = ({ lat, lng, zone, name }) => {
        this.set({ latitude: lat.toFixed(6), longitude: lng.toFixed(6), ...(zone || {}) });
        if (!zone) alert("", "warning", t("warning"), t("address_out_of_range"));
        this.MatchProject(name);
    };

    /* -------------------------------------------------------- ข้อมูลโครงการ
     * ค้นหาตำแหน่งที่ตั้งจากแผนที่แล้ว ต้องเช็กด้วยว่าสถานที่นั้นมีในข้อมูลโครงการหรือยัง
     *   มีแล้ว   → เลือกโครงการนั้นขึ้นให้อัตโนมัติ แล้วตอนบันทึกจะอัปเดตทำเลของโครงการตามหมุดใหม่
     *   ยังไม่มี → ตอนบันทึกจะสร้างโครงการให้ด้วยชื่อสถานที่นี้ แล้วผูกทรัพย์เข้ากับโครงการที่สร้าง
     * (หน้า "โครงการ" ทำแบบเดียวกัน — page/admin/projects.js)
     *
     * ทำจริงตอนกดบันทึกเท่านั้น ตรงนี้แค่จดไว้ว่าจะทำอะไร เพราะผู้ใช้ยังขยับหมุด/แก้ทำเล
     * ต่อได้อีกหลายรอบก่อนบันทึก ถ้ายิง API ทุกครั้งที่ค้นหาจะได้โครงการขยะเต็มระบบ
     * ------------------------------------------------------------------- */
    MatchProject = async (placeName) => {
        const name = normalizeName(placeName || this.state.data.place_search);
        if (!name) return this.setState({ project_sync: null });

        const project = await findProjectByName(name);

        if (!project) {
            /* มีโครงการที่เลือกไว้อยู่แล้ว = ผู้ใช้แค่ขยับหมุดให้ตรงยูนิต ไม่ได้จะตั้งโครงการใหม่
               (ล้างโครงการในช่องเลือกก่อน แล้วค้นใหม่ ถ้าอยากให้สร้างโครงการจากสถานที่นี้) */
            if (this.state.data.project_uid) return this.setState({ project_sync: null });

            // จองชื่อไว้ในฟอร์มก่อน ตัวโครงการจริงค่อยสร้างตอนกดบันทึก
            this.set({ project: name });
            this.setState({ project_sync: can("projects.create") ? { mode: "create", uid: "", name, categories: [] } : null });
            return;
        }

        /* โครงการที่ปิดใช้งานอยู่ (หรือยังไม่ได้ผูกประเภทที่เลือกไว้) ไม่ได้อยู่ในรายการตัวเลือก
           ต้องยัดเข้า state ก่อน ไม่งั้นช่องเลือกโครงการจะโชว์เป็นว่างทั้งที่ผูก uid ให้แล้ว */
        const projects = this.state.projects.some((e) => e.uid === project.uid)
            ? this.state.projects.map((e) => (e.uid === project.uid ? project : e))
            : [...this.state.projects, project];

        // ไม่เอาทำเลของโครงการมาทับ เพราะหมุดที่เพิ่งปักใหม่กว่า และจะเอาไปอัปเดตโครงการตอนบันทึก
        this.set({ project_uid: project.uid, project: project.name });
        this.setState({
            projects,
            project_sync: can("projects.update")
                ? { mode: "update", uid: project.uid, name: project.name, categories: project.asset_category_uids || [] }
                : null,
        });
    };

    /* กด x บนป้าย = ไม่ต้องไปแตะข้อมูลโครงการตอนบันทึก
       โหมด "จะสร้างใหม่" ต้องคืนชื่อที่จองไว้ในฟอร์มด้วย ไม่งั้นจะเหลือชื่อโครงการค้างอยู่
       ทั้งที่ไม่มีโครงการนั้นจริงและไม่ได้ผูก uid ไว้ */
    CancelProjectSync = () => {
        if (this.state.project_sync?.mode === "create") this.set({ project: "" });
        this.setState({ project_sync: null });
    };

    /* สร้าง/อัปเดตข้อมูลโครงการให้ตรงกับตำแหน่งที่ตั้งในฟอร์ม — เรียกก่อนบันทึกทรัพย์เสมอ
       เพราะทรัพย์ต้องผูก uid ของโครงการที่เพิ่งสร้าง
       คืน false = ทำไม่สำเร็จ ให้หยุดการบันทึกไว้ก่อน (POST/PUT เด้งสาเหตุให้แล้ว)
       ไม่บันทึกทรัพย์ต่อ เพราะจะได้ป๊อปอัปซ้อนกันสองชั้นแล้วอันหลังถูกกลืนหายไป
       — อยากข้ามการสร้าง/อัปเดตโครงการก็กด x บนป้ายแล้วกดบันทึกใหม่ได้เลย
       @returns {Promise<boolean>} */
    SyncProject = async () => {
        const sync = this.state.project_sync;
        if (!sync) return true;

        const category = this.category();
        // ยังไม่รู้ประเภททรัพย์ = payload จะตีกลับอยู่ดี อย่าเพิ่งสร้างโครงการทิ้งไว้
        if (!category.uid) return true;

        const body = {
            ...projectLocationBody(this.state.data),
            /* ประเภทที่เลือกไว้ต้องอยู่ในโครงการด้วย ไม่งั้นรอบหน้าโครงการนี้จะหลุดจากตัวเลือก
               (ฟอร์มกรองโครงการด้วยประเภททรัพย์ที่เลือกในขั้นนี้) */
            asset_category_uids: [...new Set([...(sync.categories || []), category.uid].filter(Boolean))],
        };

        loading(true);
        const result =
            sync.mode === "create"
                ? await POST("admin/projects", { ...body, name: sync.name })
                : await PUT("admin/projects/" + sync.uid, body);
        loading(false);

        if (!result?.status) return false;

        const project = result.data;
        await this.setAsync({ project_uid: project.uid, project: project.name, place_search: project.name });
        this.setState({
            project_sync: null,
            projects: this.state.projects.some((e) => e.uid === project.uid)
                ? this.state.projects.map((e) => (e.uid === project.uid ? project : e))
                : [...this.state.projects, project],
        });

        return true;
    };

    /* ------------------------------------------------- จุดสนใจใกล้เคียง */
    /* เติมสถานีรถไฟฟ้าที่ใกล้หมุดที่สุดให้ — ระยะเป็นเส้นตรง ผู้ใช้แก้เป็นระยะเดินจริงได้
       ชื่อซ้ำจะถูกข้าม (เช่น ลาดพร้าว มีทั้งสายสีน้ำเงินและสีเหลือง เอาที่ใกล้กว่าพอ) */
    FillStations = () => {
        const pin = this.pinned();
        if (!pin) {
            alert("", "warning", t("warning"), t("nearby_need_pin"));
            return;
        }

        const added = nearestStations(pin, this.state.data.nearby);
        if (!added.length) {
            alert("", "warning", t("warning"), t("nearby_no_station"));
            return;
        }

        this.set({ nearby: [...this.state.data.nearby, ...added] });
        alert("", "success", t("success"), t("nearby_station_added").replace("{count}", added.length));
    };

    setNearby = (index, patch) =>
        this.set({ nearby: this.state.data.nearby.map((item, i) => (i === index ? { ...item, ...patch } : item)) });

    AddNearby = () => this.set({ nearby: [...this.state.data.nearby, { type: "mall", label: "", distance: "" }] });

    RemoveNearby = (index) => this.set({ nearby: this.state.data.nearby.filter((_, i) => i !== index) });

    toggleAmenity = (value) =>
        this.setState((prev) => ({
            data: {
                ...prev.data,
                amenities: prev.data.amenities.includes(value) ? prev.data.amenities.filter((e) => e !== value) : [...prev.data.amenities, value],
            },
        }));

    toggleFacility = (value) =>
        this.setState((prev) => ({
            data: {
                ...prev.data,
                facilities: prev.data.facilities.includes(value) ? prev.data.facilities.filter((e) => e !== value) : [...prev.data.facilities, value],
                // ปลดติ๊ก "อื่น ๆ" = ล้างข้อความที่พิมพ์ไว้ทิ้งด้วย ไม่ให้ค้างในช่องที่ซ่อนไป
                facility_other: value === "other" && prev.data.facilities.includes("other") ? "" : prev.data.facility_other,
            },
        }));

    /* ติ๊กครบทุกข้อแล้วกดอีกครั้ง = ล้างทั้งหมด (ปุ่มเดียวสลับไปมา)
       เลือกทั้งหมดไม่แตะ "อื่น ๆ" (ติ๊กเองไว้ก็คงไว้) ส่วนล้างทั้งหมดล้างข้อความของ "อื่น ๆ"
       ตามไปด้วย ไม่งั้นค่าเก่าจะค้างอยู่ในช่องที่ซ่อนไป */
    toggleAllAmenities = () =>
        this.setState((prev) => {
            const all = hasAllAmenities(prev.data.amenities);
            return {
                data: {
                    ...prev.data,
                    amenities: all ? [] : [...new Set([...prev.data.amenities, ...BULK_AMENITIES])],
                    amenity_other: all ? "" : prev.data.amenity_other,
                },
            };
        });

    AddKeyword = () => {
        const keyword = this.state.keyword.trim();
        if (!keyword) {
            this.setState({ keyword_open: false });
            return;
        }
        if (!this.state.data.keywords.includes(keyword)) {
            this.set({ keywords: [...this.state.data.keywords, keyword] });
        }
        this.setState({ keyword: "" });
    };

    RemoveKeyword = async (keyword) => {
        if (!(await alert("", "warning", t("delete_keyword"), `${t("delete_keyword_confirm")}\n"${keyword}"`, t("confirm"), t("cancel")))) return;
        this.set({ keywords: this.state.data.keywords.filter((e) => e !== keyword) });
    };

    /* ------------------------------------------------- จุดเด่น / แท็ก (ขั้น 3) */
    toggleTag = (value) =>
        this.setState((prev) => ({
            data: { ...prev.data, tags: prev.data.tags.includes(value) ? prev.data.tags.filter((e) => e !== value) : [...prev.data.tags, value] },
        }));

    AddTag = () => {
        const tag = this.state.tag_input.trim();
        if (!tag) {
            this.setState({ tag_open: false });
            return;
        }
        if (!this.state.data.tags.includes(tag)) this.set({ tags: [...this.state.data.tags, tag] });
        this.setState({ tag_input: "" });
    };

    // ผู้ช่วย AI ร่างรายละเอียดประกาศจากข้อมูลที่กรอกไว้ ให้เฉพาะภาษาของแท็บที่เปิดอยู่
    // ตอนนี้ประกอบข้อความจากเทมเพลตในเครื่อง — เมื่อต่อ backend ให้เรียก API แล้วนำผลมาใส่แทน
    GenerateDescription = async () => {
        const d = this.state.data;
        const lang = DESC_LANGS.find((e) => e.value === this.state.desc_lang) || DESC_LANGS[0];

        if (!d.project && !d.area && !d.land_area) {
            alert("", "warning", t("warning"), t("ai_need_data"));
            return;
        }
        // ยืนยันก่อนเสมอ — ถ้าแท็บนั้นมีข้อความอยู่แล้วจะเตือนเรื่องเขียนทับด้วย
        const detail = (d[lang.field] || "").trim() ? t("ai_overwrite_confirm") : t("ai_write_confirm");
        if (!(await alert("", "info", t("ai_write"), `${detail}\n${t("language")}: ${t(lang.label)}`, t("confirm"), t("cancel")))) return;

        this.set({ [lang.field]: this.draftDescription(d, lang.value) });
        alert("", "success", t("success"), t("ai_write_done"));
    };

    // ร่างข้อความตามภาษาของแท็บที่เปิดอยู่ — ทั้งโครงประโยคและคำศัพท์
    // (ไม่ใช้ t() เพราะ t() อิงภาษาที่ผู้ใช้ตั้งไว้ในระบบ ไม่ใช่ภาษาของแท็บ)
    draftDescription = (d, lang) => {
        const word = (key) => term(key, lang);
        const type = this.typeTerm(lang);
        const size = d.area || d.land_area || "-";
        const unit = word(d.area ? "sqm" : "sqw");
        const tags = d.tags.map((value) => word(TAGS.find((e) => e.value === value)?.label || value)).join(" · ");
        const amenities = d.amenities
            .map((value) => (value === "other" && d.amenity_other.trim() ? d.amenity_other.trim() : word(AMENITIES.find((e) => e.value === value)?.label || value)))
            .join(", ");
        const address = [d.soi, d.subdistrict, d.district, d.province, d.postcode].filter(Boolean).join(" ");
        const rooms = [
            Number(d.bedroom) ? `${d.bedroom} ${word("bedroom")}` : "",
            Number(d.bathroom) ? `${d.bathroom} ${word("bathroom")}` : "",
            // ที่จอดรถบอกเป็นประเภทที่จอดได้ ไม่ใช่จำนวนคันแล้ว
            ...parkingTypes(d).map((e) => word(e.label)),
        ]
            .filter(Boolean)
            .join(" · ");

        const lines = [];
        if (lang === "en") {
            lines.push(`${type} at ${d.project || address} — ${size} ${unit}${Number(d.floor) ? `, ${word("floor_label")} ${d.floor}` : ""}.`);
            if (rooms) lines.push(rooms);
            if (tags) lines.push(`Highlights: ${tags}`);
            if (amenities) lines.push(`Amenities: ${amenities}`);
            if (address) lines.push(`Location: ${address}`);
            if (isRentDeal(d.deals) && d.rent) lines.push(`Rent ${money(d.rent)} ${word("baht_per_month")}`);
            if (isSaleDeal(d.deals) && d.price) lines.push(`For sale ${money(d.price)} ${word("unit_baht")}`);
        } else if (lang === "cn") {
            lines.push(`${d.project || address}${type}，${size} ${unit}${Number(d.floor) ? `，${word("floor_label")} ${d.floor}` : ""}。`);
            if (rooms) lines.push(rooms);
            if (tags) lines.push(`亮点：${tags}`);
            if (amenities) lines.push(`设施：${amenities}`);
            if (address) lines.push(`位置：${address}`);
            if (isRentDeal(d.deals) && d.rent) lines.push(`租金 ${money(d.rent)} ${word("baht_per_month")}`);
            if (isSaleDeal(d.deals) && d.price) lines.push(`售价 ${money(d.price)} ${word("unit_baht")}`);
        } else {
            lines.push(`${type}${d.project ? ` ${d.project}` : ""} ขนาด ${size} ${unit}${Number(d.floor) ? ` ${word("floor_label")} ${d.floor}` : ""}`);
            if (rooms) lines.push(rooms);
            if (tags) lines.push(`จุดเด่น: ${tags}`);
            if (amenities) lines.push(`สิ่งอำนวยความสะดวก: ${amenities}`);
            if (address) lines.push(`ทำเล: ${address}`);
            if (isRentDeal(d.deals) && d.rent) lines.push(`ค่าเช่า ${money(d.rent)} ${word("baht_per_month")}`);
            if (isSaleDeal(d.deals) && d.price) lines.push(`ราคาขาย ${money(d.price)} ${word("unit_baht")}`);
        }
        return lines.join("\n");
    };

    /* ------------------------------------------------- จัดการรูปภาพ / ไฟล์ */
    // ไฟล์ที่ผู้ใช้เลือก/ลากเข้ามาจะถูกเก็บใน state พร้อม object URL สำหรับพรีวิว
    // (ตัวไฟล์จริงเก็บไว้ใน field `file` รอส่งด้วย UPLOAD() ตอนต่อ backend)
    makeFile = (file) => ({
        uid: `u${(this.file_seq = (this.file_seq || 0) + 1)}-${file.size}`,
        name: file.name,
        size: fileSize(file.size),
        type: file.type === "application/pdf" || /\.pdf$/i.test(file.name) ? "pdf" : "image",
        url: URL.createObjectURL(file),
        file,
    });

    revoke = (item) => item?.url && URL.revokeObjectURL(item.url);

    PickPhotos = () => this.photo_input.current?.click();

    // รับรูปทั้งจากปุ่มเลือกไฟล์และจากการลากมาวาง
    AddPhotos = (files) => {
        const list = Array.from(files || []);
        if (!list.length) return;

        const { photos, cover } = this.state.data;
        const room = MAX_PHOTOS - photos.length;
        if (room <= 0) {
            alert("", "warning", t("warning"), t("photo_limit_reached"));
            return;
        }

        const rejected = [];
        const accepted = [];
        list.forEach((file) => {
            if (!isImageFile(file)) return rejected.push(`${file.name} — ${t("file_type_invalid")}`);
            if (file.size > MAX_FILE_MB * 1048576) return rejected.push(`${file.name} — ${t("file_too_big")}`);
            if (accepted.length >= room) return rejected.push(`${file.name} — ${t("photo_limit_reached")}`);
            return accepted.push(this.makeFile(file));
        });

        if (accepted.length) this.set({ photos: [...photos, ...accepted], cover: cover || accepted[0].uid });
        if (rejected.length) alert("", "warning", t("warning"), `${t("file_skipped")}\n${rejected.join("\n")}`);
    };

    RemovePhoto = async (photo) => {
        if (!(await alert("", "warning", t("delete_photo"), `${t("delete_photo_confirm")}\n"${photo.name}"`, t("confirm"), t("cancel")))) return;
        const photos = this.state.data.photos.filter((e) => e.uid !== photo.uid);
        this.revoke(photo);
        this.set({
            photos,
            // ลบรูปหลักทิ้ง → เลื่อนรูปแรกที่เหลือขึ้นมาเป็นรูปหลักแทน
            cover: this.state.data.cover === photo.uid ? photos[0]?.uid || "" : this.state.data.cover,
        });
    };

    // ลากสลับลำดับรูป — ลำดับนี้คือลำดับที่ลูกค้าจะเห็นบนหน้าประกาศ
    DropPhoto = (target_uid) => {
        const drag_uid = this.state.drag_photo;
        this.setState({ drag_photo: "", over_photo: "" });
        if (!drag_uid || drag_uid === target_uid) return;
        const photos = [...this.state.data.photos];
        const from = photos.findIndex((e) => e.uid === drag_uid);
        const to = photos.findIndex((e) => e.uid === target_uid);
        if (from < 0 || to < 0) return;
        photos.splice(to, 0, photos.splice(from, 1)[0]);
        this.set({ photos });
    };

    /* ----------------------------------------------------------- แผนผังห้อง */
    PickFloorPlans = () => this.plan_input.current?.click();

    AddFloorPlans = (files) => {
        const list = Array.from(files || []);
        if (!list.length) return;

        const rejected = [];
        const accepted = [];
        list.forEach((file) => {
            if (!isPlanFile(file)) return rejected.push(`${file.name} — ${t("file_type_invalid")}`);
            if (file.size > MAX_FILE_MB * 1048576) return rejected.push(`${file.name} — ${t("file_too_big")}`);
            return accepted.push(this.makeFile(file));
        });

        if (accepted.length) this.set({ floor_plans: [...this.state.data.floor_plans, ...accepted] });
        if (rejected.length) alert("", "warning", t("warning"), `${t("file_skipped")}\n${rejected.join("\n")}`);
    };

    RemoveFloorPlan = async (file) => {
        if (!(await alert("", "warning", t("delete_file"), `${t("delete_file_confirm")}\n"${file.name}"`, t("confirm"), t("cancel")))) return;
        this.revoke(file);
        this.set({ floor_plans: this.state.data.floor_plans.filter((e) => e.uid !== file.uid) });
    };

    /* ------------------------------------------- เอกสารประกอบ (เฉพาะ Admin) */
    PickDocuments = () => this.doc_input.current?.click();

    AddDocuments = (files) => {
        const list = Array.from(files || []);
        if (!list.length) return;

        const rejected = [];
        const accepted = [];
        list.forEach((file) => {
            if (!isPlanFile(file)) return rejected.push(`${file.name} — ${t("file_type_invalid")}`);
            if (file.size > MAX_FILE_MB * 1048576) return rejected.push(`${file.name} — ${t("file_too_big")}`);
            return accepted.push(this.makeFile(file));
        });

        if (accepted.length) this.set({ documents: [...this.state.data.documents, ...accepted] });
        if (rejected.length) alert("", "warning", t("warning"), `${t("file_skipped")}\n${rejected.join("\n")}`);
    };

    RemoveDocument = async (file) => {
        if (!(await alert("", "warning", t("delete_file"), `${t("delete_file_confirm")}\n"${file.name}"`, t("confirm"), t("cancel")))) return;
        this.revoke(file);
        this.set({ documents: this.state.data.documents.filter((e) => e.uid !== file.uid) });
    };

    // โน้ตภายในเขียนเป็นข้อ ๆ — กด Enter แล้วขึ้นบรรทัดใหม่พร้อมหัวข้อย่อยให้เลย
    NoteBullet = (event) => {
        if (event.key !== "Enter" || event.shiftKey) return;
        const input = event.target;
        const { selectionStart: start, selectionEnd: end, value } = input;
        event.preventDefault();
        const next = `${value.slice(0, start)}\n• ${value.slice(end)}`;
        this.set({ internal_note: next });
        // คืนตำแหน่งเคอร์เซอร์ให้อยู่หลังหัวข้อย่อยที่เพิ่งใส่
        requestAnimationFrame(() => input.setSelectionRange(start + 3, start + 3));
    };

    /* ------------------------------------------------------- ตรวจความครบถ้วน */
    // ใช้ทั้งกับการกด "ถัดไป" และ checklist ในหน้า Preview
    checklist = () => {
        const d = this.state.data;
        return [
            { key: "check_type", ok: !!(d.deals || []).length && !!d.type, step: 1 },
            { key: "check_location", ok: !!d.province && !!d.district && !!d.subdistrict, step: 1 },
            { key: "check_photos", ok: d.photos.length >= 3, step: 2 },
            // ค่าเช่าไม่บังคับ (ประกาศบางรายการยังไม่เคาะราคา) เหลือตรวจเฉพาะราคาขายของประกาศขาย
            { key: "check_price", ok: !isSaleDeal(d.deals) || !!d.price, step: 3 },
            // ที่ดินต้องมีเนื้อที่ (ตร.ว.) ส่วนพื้นที่ใช้สอย (ตร.ม.) ของประเภทอื่นไม่บังคับ
            { key: "check_specs", ok: !isLandType(d.type) || !!d.land_area, step: 3 },
            { key: "check_description", ok: !!d.description_th.trim(), step: 3 },
            { key: "check_owner", ok: !!d.owner_name.trim() && !!d.owner_phone.trim(), step: 4 },
            // เอกสารประกอบเป็นข้อมูลภายในของ Admin — ไม่บังคับ จึงไม่นับรวมในเงื่อนไขการเผยแพร่
        ];
    };

    // เงื่อนไขขั้นต่ำของแต่ละขั้นก่อนไปขั้นถัดไป (คืน key ของข้อความเตือน หรือ "" เมื่อผ่าน)
    validateStep = (step) => {
        const d = this.state.data;
        if (step === 1) {
            if (!(d.deals || []).length) return "verify_listing_type";
            if (!d.type) return "verify_property_type";
            // ทรัพย์ใหม่ต้องได้รหัสจาก KEY ของประเภท ประเภทที่ยังไม่ได้ตั้งไว้จึงไปต่อไม่ได้
            if (this.is_create && !this.typePrefix(d.type)) return "verify_type_prefix";
            if (!d.province || !d.district || !d.subdistrict) return "verify_location";
        }
        if (step === 2 && !d.photos.length) return "verify_photos";
        if (step === 3) {
            // รหัสทรัพย์ไม่ต้องตรวจ — ระบบออกให้ตอนบันทึกจาก KEY ของประเภทที่เลือกไว้
            // พื้นที่ใช้สอย (ตร.ม.) กับค่าเช่าไม่บังคับ — ที่ดินยังต้องมีเนื้อที่ (ตร.ว.) เพราะไม่มีสเปกอื่นให้ดูเลย
            if (isLandType(d.type) && !d.land_area) return "verify_area";
            if (isSaleDeal(d.deals) && !d.price) return "verify_price";
        }
        if (step === 4) {
            if (!d.owner_name.trim()) return "verify_owner_name";
            if (!d.owner_phone.trim()) return "verify_owner_phone";
        }
        return "";
    };

    goStep = (step) => {
        if (step < 1 || step > STEPS.length) return;
        this.setState({ step }, () => window.scrollTo({ top: 0, behavior: "smooth" }));
    };

    Next = () => {
        const error = this.validateStep(this.state.step);
        if (error) {
            alert("", "warning", t("warning"), t(error));
            return;
        }
        this.goStep(this.state.step + 1);
    };

    // กดที่หัวขั้นตอน — ถอยกลับไปแก้ขั้นก่อนหน้าได้เสมอ
    // ตอน "สร้างใหม่" ห้ามข้ามขั้น : เดินหน้าได้ทีละขั้นและต้องกรอกขั้นปัจจุบันครบก่อน
    // (ตอนแก้ไขทรัพย์เดิมข้อมูลมีอยู่แล้ว จึงกระโดดไปขั้นไหนก็ได้ถ้าขั้นก่อน ๆ ผ่าน)
    JumpStep = (step) => {
        if (step <= this.state.step) {
            this.goStep(step);
            return;
        }
        if (this.is_create && step > this.state.step + 1) {
            alert("", "warning", t("warning"), t("warn_no_skip_step"));
            return;
        }
        for (let i = this.state.step; i < step; i += 1) {
            const error = this.validateStep(i);
            if (error) {
                alert("", "warning", t("warning"), t(error));
                return;
            }
        }
        this.goStep(step);
    };

    /* --------------------------------------------------------------- บันทึก */
    Cancel = async () => {
        const title = this.is_create ? "cancel_add_property" : "cancel_edit_property";
        if (await alert("", "warning", t(title), t("cancel_add_property_desc"), t("confirm"), t("cancel"))) {
            this.props.router.navigate("/ad/assets");
        }
    };

    /* อัปโหลดไฟล์ที่เพิ่งเลือกจากเครื่องขึ้น R2 แล้วคืนรายการที่พร้อมส่งไปกับประกาศ
       ไฟล์ที่อยู่บนระบบแล้วส่ง uid เดิมกลับไป (ฝั่ง API จะได้รู้ว่าไม่ใช่ไฟล์ใหม่)
       คืน null เมื่ออัปโหลดไม่สำเร็จ เพื่อให้ผู้เรียกยกเลิกการบันทึกทั้งชุด */
    uploadFiles = async (list, folder, cover) => {
        const uploaded = [];

        for (const [index, item] of (list || []).entries()) {
            const common = { sequence: index + 1, ...(cover ? { is_cover: item.uid === cover } : {}) };

            if (!item.file) {
                uploaded.push({ uid: item.uid, file_path: item.url, file_name: item.name, mime_type: item.mime_type || undefined, ...common });
                continue;
            }

            const result = await UPLOAD(item.file, { folder });
            if (!result?.status) {
                /* ต้องโชว์ result.message ด้วย ไม่ใช่แค่ชื่อไฟล์ — UPLOAD() บอกสาเหตุจริงมาแล้ว
                   (เช่น "R2 storage is not configured — missing ..." หรือ 403 จาก CORS ของบักเก็ต)
                   ถ้ากลืนทิ้งจะเหลือแค่ "อัปโหลดไฟล์ไม่สำเร็จ" ซึ่งไล่ต่อไม่ได้เลย */
                alert("", "warning", t("warning"), `${t("upload_failed")}\n${item.name}\n${result?.message || ""}`.trim());
                return null;
            }

            uploaded.push({
                file_path: result.data.file_path,
                file_name: result.data.file_name || item.name,
                mime_type: result.data.mime_type || undefined,
                file_size: result.data.file_size ?? undefined,
                ...common,
            });
        }

        return uploaded;
    };

    /* โครง body ที่ส่งขึ้น API
       ประเภททรัพย์ส่งเป็น uid ของข้อมูล master (ฝั่ง API เก็บลงตารางเป็น id)
       ช่องที่ปล่อยว่างส่งเป็น "-" เพราะ removeEmptyString ตัดค่า null/"" ทิ้งก่อนส่ง
       ซึ่งจะกลายเป็น "ไม่ได้แก้ฟิลด์นี้" แทนที่จะเป็น "ล้างค่า" */
    payload = async (publishMode) => {
        const d = this.state.data;
        const is_land = isLandType(d.type);
        const is_house = isHouseType(d.type);
        const num = (value) => (String(value ?? "").trim() === "" ? "-" : Number(value));
        const text = (value) => (String(value ?? "").trim() === "" ? "-" : String(value).trim());

        const category = this.category();
        if (!category.uid) {
            alert("", "warning", t("warning"), t("verify_property_type"));
            return null;
        }

        const photos = await this.uploadFiles(d.photos, "assets/photo", d.cover || d.photos[0]?.uid);
        if (!photos) return null;
        const floor_plans = await this.uploadFiles(d.floor_plans, "assets/floor-plan");
        if (!floor_plans) return null;
        const documents = await this.uploadFiles(d.documents, "assets/document");
        if (!documents) return null;

        return {
            /* ขั้นที่ 1 — ข้อมูลทรัพย์ */
            asset_category_uid: category.uid,
            deals: d.deals,
            headline: text(d.headline),
            // ฝั่ง API จะทับชื่อโครงการด้วยชื่อจากตาราง master ให้เอง เมื่อส่ง project_uid มา
            project_uid: text(d.project_uid),
            project: text(d.project),
            title: listingTitle(d, this.typeName()),
            keywords: d.keywords,
            province: text(d.province),
            district: text(d.district),
            subdistrict: text(d.subdistrict),
            soi: text(d.soi),
            postcode: text(d.postcode),
            latitude: num(d.latitude),
            longitude: num(d.longitude),
            // ตัดแถวที่ยังไม่ได้ตั้งชื่อทิ้ง ไม่งั้นจะได้จุดสนใจเปล่า ๆ ไปโผล่บนหน้าประกาศ
            nearby: d.nearby
                .filter((e) => e.label.trim())
                .map((e) => ({ type: e.type, label: e.label.trim(), distance: num(e.distance) })),

            /* ขั้นที่ 2 — รูปภาพ / วิดีโอ */
            photos,
            floor_plans,
            video_provider: d.video_provider,
            video_url: text(d.video_url),

            /* ขั้นที่ 3 — รายละเอียด */
            code: d.code.trim(),
            area: is_land ? "-" : num(d.area),
            // บ้านแนวราบมีทั้งพื้นที่ดินและพื้นที่ใช้สอย ประเภทอื่นส่งเฉพาะช่องที่ฟอร์มโชว์ไว้
            land_area: is_land || is_house ? num(d.land_area) : "-",
            floor_count: is_house ? num(d.floor_count) : "-",
            // แนวราบไม่มีชั้นที่ตั้งอยู่/ตึก — ส่งค่าล้างไปด้วย ไม่ให้ค่าเดิมค้างหลังสลับประเภท
            floor: is_house ? "-" : num(d.floor),
            building: is_house ? "-" : text(d.building),
            bedroom: num(d.bedroom),
            bathroom: num(d.bathroom),
            living_room: num(d.living_room),
            kitchen: num(d.kitchen),
            parking_motorcycle: !!d.parking_motorcycle,
            parking_car: !!d.parking_car,
            // จอดแบบนั้นไม่ได้ = ล้างจำนวนคันทิ้ง ไม่ให้เหลือตัวเลขค้างจากตอนที่เคยติ๊กไว้
            parking_motorcycle_count: d.parking_motorcycle ? num(d.parking_motorcycle_count) : "-",
            parking_car_count: d.parking_car ? num(d.parking_car_count) : "-",
            direction: text(d.direction),
            built_year: num(d.built_year),
            rent: num(d.rent),
            contract_term: num(d.contract_term),
            // ไม่ได้ระบุระยะสัญญา = ล้างหน่วยทิ้งด้วย ไม่ให้เหลือหน่วยลอย ๆ ที่ไม่มีตัวเลขคู่กัน
            contract_unit: Number(d.contract_term) ? text(d.contract_unit) : "-",
            price: num(d.price),
            deposit: num(d.deposit),
            advance_month: d.advance_use ? num(d.advance_month) : 0,
            move_in_payment: num(d.move_in_payment),
            common_fee: num(d.common_fee),
            common_fee_included: !!d.common_fee_included,
            special_terms: text(d.special_terms),
            amenities: d.amenities,
            amenity_other: d.amenities.includes("other") ? text(d.amenity_other) : "-",
            decoration: text(d.decoration),
            furnished: text(d.furnished),
            facilities: d.facilities,
            // ไม่ได้ติ๊ก "อื่น ๆ" ของส่วนกลาง = ล้างข้อความทิ้ง ไม่ให้ค้างแบบที่ฟอร์มไม่โชว์
            facility_other: d.facilities.includes("other") ? text(d.facility_other) : "-",
            pet_allowed: !!d.pet_allowed,
            tags: d.tags,
            description_th: text(d.description_th),
            description_en: text(d.description_en),
            description_cn: text(d.description_cn),
            available_at: text(d.available_at),

            /* ขั้นที่ 4 — ข้อมูลภายใน (ไม่แสดงหน้าเว็บ) */
            owner_name: text(d.owner_name),
            owner_phone: text(d.owner_phone),
            owner_line: text(d.owner_line),
            owner_facebook: text(d.owner_facebook),
            owner_email: text(d.owner_email),
            owner_overseas: d.owner_overseas,
            water_fee: num(d.water_fee),
            common_fee_month: num(d.common_fee_month),
            co_agent_use: d.co_agent_use,
            co_agent_share: d.co_agent_use ? num(d.co_agent_share) : "-",
            co_agent_name: d.co_agent_use ? text(d.co_agent_name) : "-",
            co_agent_phone: d.co_agent_use ? text(d.co_agent_phone) : "-",
            documents,
            internal_note: text(d.internal_note),
            // เปลี่ยนเป็นขายแล้ว/ปล่อยเช่าแล้ว = API ปิดดีลและออกรหัสดีลให้เอง
            status: d.status,

            /* ขั้นที่ 5 — การเผยแพร่ */
            publish_mode: publishMode,
            publish_at: publishMode === "schedule" ? `${d.publish_at} ${d.publish_time}` : "-",
        };
    };

    /* บันทึกลงฐานข้อมูล — ใช้ร่วมกันทั้งปุ่มบันทึกแบบร่างและปุ่มเผยแพร่
       บันทึกครั้งแรกสำเร็จแล้วจะสลับเป็นโหมดแก้ไขทันที กันกดซ้ำแล้วได้ประกาศซ้ำ */
    Save = async (publishMode) => {
        // รหัสทรัพย์ออกจาก KEY ของประเภท ถ้าประเภทนั้นยังไม่ได้ตั้ง KEY ก็บันทึกทรัพย์ใหม่ไม่ได้
        if (this.is_create && !this.typePrefix()) {
            alert("", "warning", t("warning"), t("verify_type_prefix"));
            return null;
        }

        /* ค้นตำแหน่งที่ตั้งมาจากแผนที่ → จัดการข้อมูลโครงการให้เสร็จก่อน
           ต้องมาก่อนเสมอ เพราะ payload ต้องใช้ uid ของโครงการที่เพิ่งสร้าง */
        if (!(await this.SyncProject())) return null;

        loading(true);
        const body = await this.payload(publishMode);
        if (!body) {
            loading(false);
            return null;
        }

        const result = this.is_create ? await POST("admin/assets", body) : await PUT("admin/assets/" + this.uid, body);
        loading(false);

        if (!result?.status) return null;

        if (this.is_create) {
            this.uid = result.data.uid;
            this.is_create = false;
        }

        // ไฟล์ที่เพิ่งอัปโหลดกลายเป็นไฟล์บนระบบแล้ว โหลดกลับมาให้ state ตรงกับฐานข้อมูล
        // และคืนหน่วยความจำของ object URL ที่ใช้พรีวิวก่อนอัปโหลด
        const { photos, floor_plans, documents } = this.state.data;
        [...photos, ...floor_plans, ...documents].filter((e) => e.file).forEach(this.revoke);

        this.setState({ data: this.toForm(result.data) });

        return result;
    };

    SaveDraft = async () => {
        const result = await this.Save("draft");
        if (result) alert("", "success", t("success"), t("draft_saved"));
    };

    // ปุ่มสุดท้ายทำงานตามตัวเลือกการเผยแพร่ที่เลือกไว้ (เผยแพร่ทันที / ตั้งเวลา / เก็บเป็นแบบร่าง)
    Submit = async () => {
        const d = this.state.data;
        const mode = publishMode(d);

        // แบบร่างยังกรอกไม่ครบก็บันทึกได้ แต่ถ้าจะขึ้นหน้าเว็บต้องครบทุกข้อ
        if (mode.value !== "draft") {
            const incomplete = this.checklist().filter((e) => !e.ok);
            if (incomplete.length) {
                alert("", "warning", t("warning"), `${t("publish_incomplete")}\n${incomplete.map((e) => `• ${t(e.key)}`).join("\n")}`);
                return;
            }
        }
        if (mode.value === "schedule" && (!d.publish_at || !d.publish_time)) {
            alert("", "warning", t("warning"), t("verify_publish_at"));
            return;
        }

        const detail =
            mode.value === "schedule"
                ? `${t(mode.confirm)}\n${t("publish_date")}: ${d.publish_at} ${t("time_at")} ${d.publish_time} ${t("hour_unit")}`
                : t(mode.confirm);
        if (!(await alert("", "info", t(mode.action), detail, t("confirm"), t("cancel")))) return;

        const result = await this.Save(mode.value);
        if (!result) return;

        alert("", "success", t("success"), t(mode.done));
        setTimeout(() => this.props.router.navigate("/ad/assets"), 900);
    };

    /* ================================================== render : ชิ้นส่วนย่อย */
    // ฟิลด์ข้อความมาตรฐาน — ลดโค้ดซ้ำในทุกขั้นตอน
    input = (key, label, options = {}) => {
        const { placeholder, required, unit, numeric, maxLength, hint, disabled, type = "text" } = options;
        return (
            <>
                <label className="prop-label">
                    {t(label)}
                    {required && <span className="pf-req">*</span>}
                </label>
                <div className="position-relative">
                    <input
                        type={type}
                        className="prop-field"
                        style={unit ? { paddingRight: "52px" } : undefined}
                        placeholder={placeholder ? t(placeholder) : ""}
                        value={this.state.data[key]}
                        maxLength={maxLength}
                        disabled={disabled}
                        onChange={(e) => (!numeric || (numeric === "signed" ? signedDigits : digits)(e.target.value)) && this.set({ [key]: e.target.value })}
                    />
                    {unit && (
                        <span className="position-absolute text-12" style={{ right: "12px", top: "50%", transform: "translateY(-50%)", color: "var(--prop-muted)" }}>
                            {t(unit)}
                        </span>
                    )}
                </div>
                {hint && <div className="pf-hint">{t(hint)}</div>}
            </>
        );
    };

    select = (key, label, options, extra = {}) => (
        <>
            <label className="prop-label">
                {t(label)}
                {extra.required && <span className="pf-req">*</span>}
            </label>
            {/* clearable = โชว์ตัวเลือก "ไม่เลือก" ในดรอปดาวน์ ใช้กับช่องที่ไม่บังคับ
                (ไม่งั้นเลือกไปแล้วผู้ใช้เอาออกเองไม่ได้ ต้องล้างทั้งฟอร์มอย่างเดียว) */}
            <Select
                className="prop-field prop-select"
                default={extra.clearable === true}
                placeholder={extra.placeholder ? t(extra.placeholder) : t("please_select")}
                value={this.state.data[key]}
                options={options}
                disabled={extra.disabled}
                onChange={(value, option) => (extra.onChange ? extra.onChange(value, option) : this.set({ [key]: value }))}
            />
        </>
    );

    /* ป้ายบอกว่าจะทำอะไรกับ "ข้อมูลโครงการ" ตอนกดบันทึก — ต้องเห็นก่อนบันทึก ไม่ใช่รู้ตอนทำไปแล้ว
       กด x = ทิ้งงานนั้น (ทรัพย์ยังผูกโครงการเดิมอยู่ แค่ไม่ไปแตะข้อมูลโครงการ) */
    renderProjectSync = () => {
        const sync = this.state.project_sync;
        if (!sync) return null;

        return (
            <div className={`pf-note mt-2 ${sync.mode === "create" ? "pf-note--new" : "pf-note--info"}`}>
                <span className="icon">{sync.mode === "create" ? "\uf067" : "\uf05a"}</span>
                <div className="flex-grow-1">{t(sync.mode === "create" ? "project_sync_create" : "project_sync_update").replace("{name}", sync.name)}</div>
                <button type="button" className="pf-note__x icon" title={t("cancel")} onClick={this.CancelProjectSync}>
                    {"\uf00d"}
                </button>
            </div>
        );
    };

    // แผนที่ Google Maps — คลิกหรือลากหมุดเพื่อกำหนดพิกัด (ชุดเดียวกับหน้า asset ของ munera)
    renderMap = () => {
        const d = this.state.data;
        const pin = this.pinned();

        if (!MAP_KEY) {
            return (
                <div className="pf-map pf-map--empty">
                    <span className="icon text-18 mb-2">{""}</span>
                    <span className="text-12">{t("map_key_missing")}</span>
                </div>
            );
        }

        return (
            <div className="pf-map">
                {/* ใช้ LoadScriptNext ไม่ใช่ LoadScript — LoadScript แทรก <div> เปล่าไว้เป็นลูกตัวแรก
                    (ไปโดน .pf-map > div:first-child ดันแผนที่ตกขอบกล่องที่ overflow:hidden)
                    และตอน unmount มันลบ window.google ทิ้ง ทำให้เข้าหน้านี้รอบสองแล้วค้างที่ "กำลังโหลด" */}
                <LoadScriptNext
                    googleMapsApiKey={MAP_KEY}
                    libraries={MAP_LIBRARIES}
                    language="th"
                    region="TH"
                    loadingElement={<div className="pf-map__loading">{t("map_loading")}</div>}
                    onLoad={this.MapLoaded}
                >
                    <GoogleMap mapContainerStyle={MAP_CONTAINER_STYLE} center={pin || MAP_CENTER_DEFAULT} zoom={pin ? 16 : 11} options={MAP_OPTIONS} onClick={this.PinMap}>
                        {pin && <Marker position={pin} draggable onDragEnd={this.PinMap} />}
                    </GoogleMap>
                </LoadScriptNext>
                <span className="pf-map__badge">{pin ? `${d.subdistrict || "-"} · ${d.district || "-"}` : t("map_no_pin")}</span>
            </div>
        );
    };

    /* จุดสนใจใกล้เคียง — ต่อท้ายส่วนพิกัดในขั้นตอนที่ 1 */
    renderNearby = () => {
        const list = this.state.data.nearby || [];

        return (
            <div className="pf-section">
                <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                    <div className="pf-subtitle mb-0">
                        <span className="icon">{"\uf3c5"}</span>
                        {t("nearby_places")}
                    </div>
                    <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.FillStations}>
                        <span className="icon text-12">{"\uf238"}</span>
                        {t("nearby_fill_station")}
                    </button>
                </div>

                <div className="pf-doclist mt-2">
                    {list.map((item, index) => (
                        <div key={index} className="pf-doc">
                            <div className="row g-2 flex-grow-1" style={{ minWidth: 0 }}>
                                <div className="col-5 col-md-3">
                                    <Select
                                        className="prop-field prop-select"
                                        default={false}
                                        placeholder={t("please_select")}
                                        value={item.type}
                                        options={NEARBY_TYPES.map((e) => ({ value: e.value, label: t(e.label) }))}
                                        onChange={(value) => value && this.setNearby(index, { type: value })}
                                    />
                                </div>
                                <div className="col-7 col-md-6">
                                    <input
                                        type="text"
                                        className="prop-field"
                                        placeholder={t("nearby_label_placeholder")}
                                        value={item.label}
                                        onChange={(e) => this.setNearby(index, { label: e.target.value })}
                                    />
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className="pf-suffix">
                                        <input
                                            type="text"
                                            className="prop-field"
                                            placeholder="0.00"
                                            value={item.distance}
                                            onChange={(e) => digits(e.target.value) && this.setNearby(index, { distance: e.target.value })}
                                        />
                                        <span className="pf-suffix__unit">{t("unit_km_short")}</span>
                                    </div>
                                </div>
                            </div>
                            <button type="button" className="pf-doc__x icon" title={t("delete")} onClick={() => this.RemoveNearby(index)}>
                                {"\uf00d"}
                            </button>
                        </div>
                    ))}

                    {!list.length && (
                        <div className="pf-doc pf-doc--empty">
                            <span className="pf-doc__icon icon">{"\uf3c5"}</span>
                            <span className="text-12 text-secondary">{t("nearby_empty")}</span>
                        </div>
                    )}
                </div>

                <button type="button" className="pf-tagadd mt-2" onClick={this.AddNearby}>
                    <span className="icon text-12">{"\uf067"}</span>
                    {t("nearby_add")}
                </button>

                <div className="pf-hint">
                    {t("nearby_hint")} · {t("nearby_straight_line")}
                </div>
            </div>
        );
    };

    renderSteps = () => {
        const { step } = this.state;
        return (
            <div className="prop-card prop-in mb-3">
                <div className="pf-steps" style={{ gridTemplateColumns: `repeat(${STEPS.length}, 1fr)` }}>
                    {STEPS.map((s) => {
                        // ตอนสร้างใหม่ ขั้นที่ไกลกว่า "ขั้นถัดไป" ยังกดไม่ได้ — ใส่กุญแจให้เห็นชัด
                        const locked = this.is_create && s.no > step + 1;
                        return (
                            <button
                                key={s.no}
                                type="button"
                                title={locked ? t("warn_no_skip_step") : t(s.label)}
                                className={`pf-step ${s.no < step ? "is-done" : ""} ${s.no === step ? "is-active" : ""} ${locked ? "is-locked" : ""}`}
                                onClick={() => this.JumpStep(s.no)}
                            >
                                <span className="pf-step__dot">
                                    {s.no < step ? <span className="icon text-12">{"\uf00c"}</span> : locked ? <span className="icon text-10">{"\uf023"}</span> : s.no}
                                </span>
                                <span className="pf-step__label">{t(s.label)}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    };

    /* ============================================ ขั้นที่ 1 : ข้อมูลทรัพย์ */
    renderStepBasic = () => {
        const d = this.state.data;
        const { keyword, keyword_open } = this.state;
        // ตัวเลือกทำเลไล่ตามลำดับ จังหวัด → เขต/อำเภอ → แขวง/ตำบล (ข้อมูลจาก th_province.json)
        const { provinceOptions, districtOptions, subdistrictOptions } = zoneOptions(d.province, d.district);

        return (
            <div className="row g-3">
                {/* ---------------------------------------------------- ข้อมูลพื้นฐาน */}
                <div className="col-xl-5 col-lg-6">
                    <div className="prop-card prop-in h-100">
                        <div className="prop-card__head">
                            <span className="prop-title text-16">
                                <span className="prop-title__dot" />
                                {t("basic_information")}
                            </span>
                        </div>
                        <div className="p-4">
                            <div className="pf-section">
                                <label className="prop-label">
                                    {t("listing_type")}
                                    <span className="pf-req">*</span>
                                </label>
                                <div className="pf-seg">
                                    {DEALS.map((deal) => {
                                        const on = (d.deals || []).includes(deal.value);
                                        return (
                                            <button key={deal.value} type="button" aria-pressed={on} className={`pf-seg__btn ${on ? "is-active" : ""}`} onClick={() => this.toggleDeal(deal.value)}>
                                                <span className="pf-seg__check icon">{on ? "" : ""}</span>
                                                {t(deal.label)}
                                            </button>
                                        );
                                    })}
                                </div>
                                <div className="pf-hint">{t("listing_type_hint")}</div>
                            </div>

                            <div className="pf-section">
                                <label className="prop-label">
                                    {t("property_type")}
                                    <span className="pf-req">*</span>
                                </label>
                                <div className="pf-typegrid">
                                    {this.state.categories.map((type) => (
                                        <button
                                            key={type.uid}
                                            type="button"
                                            aria-pressed={d.type === type.code}
                                            className={`pf-type ${d.type === type.code ? "is-active" : ""}`}
                                            onClick={() => this.setType(type.code)}
                                        >
                                            <span className="icon">{type.icon}</span>
                                            <span>{categoryName(type)}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* หัวข้อไม่บังคับ — ตั้งไว้เมื่อไรจะถูกใช้เป็นชื่อประกาศแทนชื่อโครงการ
                                ปล่อยว่างไว้ = ใช้ชื่อโครงการเหมือนเดิม */}
                            <div className="pf-section">
                                {this.input("headline", "headline", {
                                    placeholder: "headline_placeholder",
                                    maxLength: 255,
                                    hint: "headline_hint",
                                })}
                            </div>

                            {/* โครงการไม่บังคับ — ทรัพย์ที่ไม่ได้อยู่ในโครงการ (บ้านเดี่ยว ที่ดิน ตึกแถว)
                                ปล่อยว่างไว้แล้วกรอกตำแหน่งที่ตั้งเองในการ์ดขวาได้เลย */}
                            <div className="pf-section">
                                {this.select("project_uid", "project", this.projectOptions(), {
                                    placeholder: "select_project_master",
                                    onChange: this.setProject,
                                    clearable: true,
                                })}
                                <div className="pf-hint">{t("project_hint")}</div>
                            </div>

                            <div className="pf-section">
                                <label className="prop-label">{t("keyword_th")}</label>
                                <div className="pf-tags mb-2">
                                    {d.keywords.map((word) => (
                                        <span key={word} className="pf-tag">
                                            {word}
                                            <button type="button" className="pf-tag__x icon" title={t("delete")} onClick={() => this.RemoveKeyword(word)}>
                                                {""}
                                            </button>
                                        </span>
                                    ))}
                                    {!d.keywords.length && <span className="text-secondary text-12">{t("keyword_empty")}</span>}
                                </div>

                                {keyword_open ? (
                                    <div className="pf-taginput">
                                        <input
                                            type="text"
                                            autoFocus
                                            className="prop-field"
                                            placeholder={t("keyword_placeholder")}
                                            value={keyword}
                                            onChange={(e) => this.setState({ keyword: e.target.value })}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") this.AddKeyword();
                                                if (e.key === "Escape") this.setState({ keyword: "", keyword_open: false });
                                            }}
                                        />
                                        <button type="button" className="prop-btn prop-btn--sm" onClick={this.AddKeyword}>
                                            {t("add")}
                                        </button>
                                        <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={() => this.setState({ keyword: "", keyword_open: false })}>
                                            {t("cancel")}
                                        </button>
                                    </div>
                                ) : (
                                    <button type="button" className="pf-tagadd" onClick={() => this.setState({ keyword_open: true })}>
                                        <span className="icon text-12">{""}</span>
                                        {t("add_keyword_th")}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* ---------------------------------------------------- ตำแหน่งที่ตั้ง */}
                <div className="col-xl-7 col-lg-6">
                    <div className="prop-card prop-in h-100">
                        <div className="prop-card__head">
                            <span className="prop-title text-16">
                                <span className="prop-title__dot" />
                                {t("location")}
                            </span>
                            <span className="text-secondary text-12">{t("location_hint")}</span>
                        </div>
                        <div className="p-4">
                            <div className="pf-section">
                                <label className="prop-label">{t("map")}</label>
                                <PlaceSearch
                                    value={d.place_search}
                                    onChange={(place_search) => this.set({ place_search })}
                                    onPick={this.PickPlace}
                                />
                                {this.renderProjectSync()}
                                {this.renderMap()}
                                <div className="pf-hint">{t("place_search_hint")}</div>
                            </div>

                            <div className="pf-section">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        {this.select("province", "province", provinceOptions, {
                                            required: true,
                                            placeholder: "select_province",
                                            onChange: this.setProvince,
                                        })}
                                    </div>
                                    <div className="col-md-6">
                                        {this.select("district", "district_amphoe", districtOptions, {
                                            required: true,
                                            placeholder: "select_district",
                                            disabled: !d.province,
                                            onChange: this.setDistrict,
                                        })}
                                    </div>
                                    <div className="col-md-6">
                                        {this.select("subdistrict", "subdistrict_tambon", subdistrictOptions, {
                                            required: true,
                                            placeholder: "select_subdistrict",
                                            disabled: !d.district,
                                            onChange: this.setSubdistrict,
                                        })}
                                    </div>
                                    <div className="col-md-6">{this.input("soi", "soi", { placeholder: "soi_placeholder" })}</div>
                                    <div className="col-md-6">{this.input("postcode", "postcode", { numeric: true, maxLength: 5 })}</div>
                                </div>
                            </div>

                            <div className="pf-section">
                                <div className="pf-subtitle">
                                    <span className="icon">{"\uf3c5"}</span>
                                    {t("coordinates")}
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-6">{this.input("latitude", "label_latitude", { numeric: "signed", placeholder: "latitude_placeholder" })}</div>
                                    <div className="col-md-6">{this.input("longitude", "label_longitude", { numeric: "signed", placeholder: "longitude_placeholder" })}</div>
                                </div>
                                <div className="pf-hint">{t("coordinates_hint")}</div>
                            </div>

                            {this.renderNearby()}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    /* ============================================ ขั้นที่ 2 : รูปภาพ / วิดีโอ */
    // ภาพย่อ 1 ใบ — ลากสลับลำดับได้ คลิกเพื่อตั้งเป็นรูปหลัก และมีปุ่ม x สำหรับลบ
    renderPhotoTile = (photo, index) => {
        const { data, drag_photo, over_photo } = this.state;
        const is_cover = data.cover === photo.uid;
        const state_class = [
            is_cover ? "is-cover" : "",
            drag_photo === photo.uid ? "is-drag" : "",
            over_photo === photo.uid ? "is-over" : "",
        ].join(" ");

        return (
            <div
                key={photo.uid}
                draggable
                className={"pf-thumb " + state_class}
                style={photo.url ? undefined : { background: photo.grad }}
                title={is_cover ? photo.name : `${photo.name} — ${t("set_cover")}`}
                onClick={() => this.set({ cover: photo.uid })}
                onDragStart={(e) => {
                    // ต้องมี payload ไม่งั้น Firefox จะไม่เริ่มลาก
                    e.dataTransfer.setData("text/plain", photo.uid);
                    e.dataTransfer.effectAllowed = "move";
                    this.setState({ drag_photo: photo.uid });
                }}
                onDragEnd={() => this.setState({ drag_photo: "", over_photo: "" })}
                onDragOver={(e) => {
                    // ลากไฟล์จากเครื่องเข้ามา ปล่อยให้กล่องแกลเลอรีด้านนอกเป็นคนรับ
                    if (hasFiles(e)) return;
                    e.preventDefault();
                    if (this.state.over_photo !== photo.uid) this.setState({ over_photo: photo.uid });
                }}
                onDrop={(e) => {
                    if (hasFiles(e)) return;
                    e.preventDefault();
                    this.DropPhoto(photo.uid);
                }}
            >
                {!!photo.url && <img src={photo.url} alt={photo.name} className="pf-thumb__img" draggable={false} />}
                {/* \u0e14\u0e32\u0e27\u0e23\u0e39\u0e1b\u0e2b\u0e25\u0e31\u0e01\u0e2d\u0e22\u0e39\u0e48\u0e21\u0e38\u0e21\u0e1a\u0e19\u0e0b\u0e49\u0e32\u0e22 \u0e1b\u0e38\u0e48\u0e21\u0e25\u0e1a\u0e2d\u0e22\u0e39\u0e48\u0e21\u0e38\u0e21\u0e1a\u0e19\u0e02\u0e27\u0e32 \u2014 \u0e25\u0e1a\u0e23\u0e39\u0e1b\u0e2b\u0e25\u0e31\u0e01\u0e44\u0e14\u0e49\u0e40\u0e2b\u0e21\u0e37\u0e2d\u0e19\u0e23\u0e39\u0e1b\u0e2d\u0e37\u0e48\u0e19
                    (\u0e25\u0e1a\u0e41\u0e25\u0e49\u0e27\u0e23\u0e39\u0e1b\u0e41\u0e23\u0e01\u0e17\u0e35\u0e48\u0e40\u0e2b\u0e25\u0e37\u0e2d\u0e08\u0e30\u0e16\u0e39\u0e01\u0e40\u0e25\u0e37\u0e48\u0e2d\u0e19\u0e02\u0e36\u0e49\u0e19\u0e21\u0e32\u0e40\u0e1b\u0e47\u0e19\u0e23\u0e39\u0e1b\u0e2b\u0e25\u0e31\u0e01\u0e41\u0e17\u0e19\u0e43\u0e2b\u0e49\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34) */}
                {is_cover && (
                    <span className="pf-thumb__star icon" title={t("cover_photo")}>
                        {"\uf005"}
                    </span>
                )}
                <button
                    type="button"
                    className="pf-thumb__x icon"
                    title={t("delete_photo")}
                    onClick={(e) => {
                        e.stopPropagation();
                        this.RemovePhoto(photo);
                    }}
                >
                    {"\uf00d"}
                </button>
                <span className="pf-thumb__no">{index + 1}</span>
            </div>
        );
    };

    renderStepMedia = () => {
        const d = this.state.data;
        const { photo_drop, plan_drop } = this.state;
        const provider = VIDEO_PROVIDERS.find((e) => e.value === d.video_provider) || VIDEO_PROVIDERS[0];

        return (
            <>
                {/* ------------------------------------------------------- รูปภาพ */}
                <div className="prop-card prop-in mb-3">
                    <div className="prop-card__head">
                        <span className="prop-title text-16">
                            <span className="prop-title__dot" />
                            {t("photos")}
                            <span className="pf-head-note">({t("photo_max_hint")})</span>
                        </span>
                        <span className="d-flex align-items-center gap-2">
                            <span className={"pf-count " + (d.photos.length >= 3 ? "is-ok" : "")}>
                                <span className="icon text-10">{"\uf030"}</span>
                                {d.photos.length} / {MAX_PHOTOS}
                            </span>
                            <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.PickPhotos}>
                                <span className="icon text-12">{"\uf382"}</span>
                                {t("upload_photo")}
                            </button>
                        </span>
                    </div>

                    <div className="p-4">
                        <label className="prop-label">{t("cover_photo_label")}</label>

                        {/* ทั้งกล่องนี้รับไฟล์ที่ลากมาวางจากเครื่อง */}
                        <div
                            className={"pf-dropzone " + (photo_drop ? "is-over" : "")}
                            onDragOver={(e) => {
                                if (!hasFiles(e)) return;
                                e.preventDefault();
                                if (!photo_drop) this.setState({ photo_drop: true });
                            }}
                            onDragLeave={(e) => {
                                if (e.currentTarget.contains(e.relatedTarget)) return;
                                this.setState({ photo_drop: false });
                            }}
                            onDrop={(e) => {
                                if (!hasFiles(e)) return;
                                e.preventDefault();
                                this.setState({ photo_drop: false });
                                this.AddPhotos(e.dataTransfer.files);
                            }}
                        >
                            <div className="pf-thumbs">
                                {d.photos.map((photo, index) => this.renderPhotoTile(photo, index))}
                                {d.photos.length < MAX_PHOTOS && (
                                    <button type="button" className="pf-addtile" onClick={this.PickPhotos}>
                                        <span className="icon">{"\uf067"}</span>
                                        <span>{t("add_photo")}</span>
                                    </button>
                                )}
                            </div>

                            {!d.photos.length && (
                                <div className="pf-dropzone__empty mt-2">
                                    <span className="pf-drop__icon icon">{"\uf382"}</span>
                                    <span className="fw-bold text-dark text-14">{t("drop_photo_here")}</span>
                                    <span className="text-12 text-secondary">{t("photo_accept")}</span>
                                    <span className="text-12 text-secondary">{t("photo_size_hint")}</span>
                                </div>
                            )}

                            <span className="pf-dropzone__veil">
                                <span className="icon me-2">{"\uf382"}</span>
                                {t("drop_photo_here")}
                            </span>
                        </div>

                        <div className="pf-hint mt-3">
                            <span className="icon me-1">{"\uf0b2"}</span>
                            {t("drag_to_reorder")} · {t("photo_accept")}
                        </div>

                        {/* ขนาดที่แนะนำ — แยกเป็นบรรทัดของตัวเองให้เห็นชัด
                            รูปที่เล็กกว่านี้จะเบลอเมื่อถูกใช้เป็นรูปหลักบนหน้าประกาศ */}
                        <div className="pf-hint mt-2">
                            <span className="icon me-1">{"\uf03e"}</span>
                            {t("photo_size_hint")}
                        </div>

                        <input
                            ref={this.photo_input}
                            type="file"
                            accept="image/*"
                            multiple
                            className="d-none"
                            onChange={(e) => {
                                this.AddPhotos(e.target.files);
                                e.target.value = ""; // เลือกไฟล์เดิมซ้ำได้
                            }}
                        />
                    </div>
                </div>

                {/* ------------------------------------------------- วิดีโอ / ลิงก์ */}
                <div className="prop-card prop-in mb-3">
                    <div className="prop-card__head">
                        <span className="prop-title text-16">
                            <span className="prop-title__dot" />
                            {t("video_or_link")}
                        </span>
                        <span className="text-secondary text-12">{t("video_optional_hint")}</span>
                    </div>

                    <div className="p-4">
                        <div className="pf-brands">
                            {VIDEO_PROVIDERS.map((item) => (
                                <button
                                    key={item.value}
                                    type="button"
                                    aria-pressed={d.video_provider === item.value}
                                    className={"pf-brand " + (d.video_provider === item.value ? "is-on" : "")}
                                    onClick={() => this.set({ video_provider: item.value })}
                                >
                                    <BrandIcon provider={item.value} />
                                    {item.label}
                                </button>
                            ))}
                        </div>

                        <div className="mt-4">
                            <label className="prop-label">
                                {t("paste_link_of")} {provider.label}
                            </label>
                            <input
                                type="text"
                                className="prop-field"
                                placeholder={provider.placeholder}
                                value={d.video_url}
                                onChange={(e) => this.set({ video_url: e.target.value })}
                            />
                            <div className="pf-hint">{t("video_url_hint")}</div>
                        </div>
                    </div>
                </div>

                {/* --------------------------------------------------- แผนผังห้อง */}
                <div className="prop-card prop-in">
                    <div className="prop-card__head">
                        <span className="prop-title text-16">
                            <span className="prop-title__dot" />
                            {t("floor_plan")}
                        </span>
                        <span className="text-secondary text-12">{t("floor_plan_hint")}</span>
                    </div>

                    <div className="p-4">
                        <div className="row g-3">
                            <div className="col-lg-6">
                                <div
                                    className={"pf-filedrop " + (plan_drop ? "is-over" : "")}
                                    onDragOver={(e) => {
                                        if (!hasFiles(e)) return;
                                        e.preventDefault();
                                        if (!plan_drop) this.setState({ plan_drop: true });
                                    }}
                                    onDragLeave={(e) => {
                                        if (e.currentTarget.contains(e.relatedTarget)) return;
                                        this.setState({ plan_drop: false });
                                    }}
                                    onDrop={(e) => {
                                        if (!hasFiles(e)) return;
                                        e.preventDefault();
                                        this.setState({ plan_drop: false });
                                        this.AddFloorPlans(e.dataTransfer.files);
                                    }}
                                >
                                    <div className="text-12 text-secondary">
                                        {t("upload_file_here")} {t("or")}
                                    </div>
                                    <button type="button" className="prop-btn prop-btn--sm mt-2 mb-2" onClick={this.PickFloorPlans}>
                                        <span className="icon text-12">{"\uf07c"}</span>
                                        {t("choose_file_from_device")}
                                    </button>
                                    <div className="pf-filedrop__note">{t("floor_plan_accept")}</div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="d-flex flex-column gap-2">
                                    {d.floor_plans.map((file) => (
                                        <div key={file.uid} className="pf-file">
                                            {file.type === "image" && file.url ? (
                                                <img src={file.url} alt={file.name} className="pf-file__thumb" />
                                            ) : (
                                                <span className="pf-file__icon icon">{"\uf1c1"}</span>
                                            )}
                                            <span className="flex-grow-1 overflow-hidden">
                                                <span className="pf-file__name text-truncate">{file.name}</span>
                                                <span className="pf-file__size">{file.size}</span>
                                            </span>
                                            {!!file.url && (
                                                <a className="pf-file__x icon" href={file.url} target="_blank" rel="noreferrer" title={t("view")}>
                                                    {"\uf06e"}
                                                </a>
                                            )}
                                            <button type="button" className="pf-file__x icon" title={t("delete_file")} onClick={() => this.RemoveFloorPlan(file)}>
                                                {"\uf00d"}
                                            </button>
                                        </div>
                                    ))}
                                    {!d.floor_plans.length && (
                                        <div className="pf-file pf-file--empty">
                                            <span className="pf-file__icon icon">{"\uf15b"}</span>
                                            <span className="text-12 text-secondary">{t("no_floor_plan_yet")}</span>
                                        </div>
                                    )}
                                </div>

                                <input
                                    ref={this.plan_input}
                                    type="file"
                                    accept=".jpg,.jpeg,.png,.pdf,image/*,application/pdf"
                                    multiple
                                    className="d-none"
                                    onChange={(e) => {
                                        this.AddFloorPlans(e.target.files);
                                        e.target.value = "";
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    /* ============================================== ขั้นที่ 3 : รายละเอียด */
    // ฟิลด์ที่มีหน่วยต่อท้ายกล่อง (บาท / เดือน, %, ...) — ใช้ซ้ำหลายที่ในการ์ดราคา
    unitField = (label, key, options = {}) => {
        const { suffix, required, placeholder, disabled, numeric = true, amount } = options;
        const value = this.state.data[key];
        return (
            <>
                <label className="prop-label">
                    {t(label)}
                    {required && <span className="pf-req">*</span>}
                </label>
                <div className="pf-suffix">
                    <input
                        type="text"
                        className="prop-field"
                        disabled={disabled}
                        placeholder={placeholder ? t(placeholder) : ""}
                        // ช่องจำนวนเงินโชว์ลูกน้ำคั่นหลักพัน แต่เก็บลง state เป็นตัวเลขล้วนเสมอ
                        value={amount ? moneyInput(value) : value}
                        onChange={(e) => {
                            const next = amount ? e.target.value.replace(/,/g, "") : e.target.value;
                            if (!numeric || digits(next)) this.set({ [key]: next });
                        }}
                    />
                    {!!suffix && <span className="pf-suffix__unit">{t(suffix)}</span>}
                </div>
            </>
        );
    };

    renderStepDetails = () => {
        const d = this.state.data;
        const { desc_lang, tag_open, tag_input } = this.state;
        const is_land = isLandType(d.type);
        const is_house = isHouseType(d.type);
        const lang = DESC_LANGS.find((e) => e.value === desc_lang) || DESC_LANGS[0];
        const text = d[lang.field] || "";

        return (
            <>
                <div className="row g-3 mb-3">
                    {/* ------------------------------------------- รายละเอียดหลัก */}
                    <div className="col-xl-4 col-lg-6">
                        <div className="prop-card prop-in h-100">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("main_details")}
                                </span>
                            </div>
                            <div className="p-4">
                                <div className="row g-3">
                                    {/* รหัสทรัพย์ระบบออกให้จาก KEY ของประเภท จึงล็อกช่องไว้ (ดู หน้าประเภททรัพย์) */}
                                    <div className="col-6">
                                        {this.input("code", "property_code", {
                                            required: true,
                                            disabled: true,
                                            placeholder: "property_code_placeholder",
                                            hint: !this.is_create ? "property_code_locked_hint" : this.typePrefix() ? "property_code_auto_hint" : "verify_type_prefix",
                                        })}
                                    </div>
                                    {/* ขนาดทรัพย์ — ที่ดินกรอกแค่เนื้อที่ (ตร.ว.)
                                        บ้านแนวราบมีที่ดินของตัวเอง จึงกรอกได้ทั้งที่ดินและพื้นที่ใช้สอย
                                        และนับจำนวนชั้นของตัวบ้านได้ (คนละอย่างกับช่อง "ชั้น" ที่แปลว่า
                                        ห้องอยู่ชั้นที่เท่าไรของคอนโด) ประเภทอื่นไม่โชว์สองช่องนี้
                                        และค่าถูกล้างทิ้งตอนสลับประเภท (ดู setType) */}
                                    {is_land ? (
                                        <div className="col-6">{this.input("land_area", "land_area_sqw", { required: true, numeric: true, unit: "sqw" })}</div>
                                    ) : (
                                        <>
                                            {is_house && <div className="col-6">{this.input("land_area", "land_area_sqw", { numeric: true, unit: "sqw" })}</div>}
                                            <div className="col-6">{this.input("area", "usable_area_sqm", { numeric: true, unit: "sqm" })}</div>
                                            {is_house && <div className="col-6">{this.input("floor_count", "floor_count", { numeric: true, maxLength: 2, unit: "floor_label" })}</div>}
                                        </>
                                    )}
                                    {/* บ้านแนวราบไม่ได้อยู่ในตึกและไม่มี "ชั้นที่ตั้งอยู่" (นับเป็นจำนวนชั้นของตัวบ้านแทน)
                                        จึงไม่โชว์สองช่องนี้ และล้างค่าทิ้งตอนสลับมาเป็นแนวราบ (ดู setType) */}
                                    {!is_house && (
                                        <>
                                            <div className="col-6">{this.input("floor", "floor_label", { numeric: true })}</div>
                                            <div className="col-6">{this.input("building", "building", { placeholder: "building_placeholder", maxLength: 50 })}</div>
                                        </>
                                    )}
                                    <div className="col-6">{this.input("bedroom", "bedroom", { numeric: true, unit: "room_unit" })}</div>
                                    <div className="col-6">{this.input("bathroom", "bathroom", { numeric: true, unit: "room_unit" })}</div>
                                    <div className="col-6">{this.input("living_room", "living_room", { numeric: true, unit: "room_unit" })}</div>
                                    <div className="col-6">{this.input("kitchen", "kitchen", { numeric: true, unit: "room_unit" })}</div>
                                    <div className="col-6">
                                        {this.select(
                                            "direction",
                                            "direction",
                                            DIRECTIONS.map((e) => ({ value: e.value, label: t(e.label) }))
                                        )}
                                    </div>
                                    <div className="col-6">{this.input("built_year", "built_year", { numeric: true, maxLength: 4, placeholder: "built_year_placeholder" })}</div>
                                    {/* ที่จอดรถ — ติ๊กประเภทที่จอดได้ ติ๊กพร้อมกันได้ทั้งคู่ ไม่ติ๊กเลย = ไม่มีที่จอด
                                        ช่องจำนวนคันโชว์ไว้ทั้งคู่เสมอ แต่ล็อกช่องของแบบที่ยังไม่ได้ติ๊ก
                                        (ไม่ซ่อน เพื่อให้เห็นว่ากรอกจำนวนได้ ไม่ใช่หายไปเฉย ๆ)
                                        ปลดติ๊ก = ล้างจำนวนทิ้งทันที ไม่ให้ตัวเลขเก่าค้างอยู่ในช่องที่ล็อกไว้ */}
                                    <div className="col-12">
                                        <label className="prop-label">{t("parking")}</label>
                                        <div className="pf-checks">
                                            {PARKING_TYPES.map((item) => (
                                                <label key={item.value} className={"pf-checkline " + (d[item.key] ? "is-on" : "")}>
                                                    <input
                                                        type="checkbox"
                                                        checked={!!d[item.key]}
                                                        onChange={(e) => this.set({ [item.key]: e.target.checked, ...(e.target.checked ? {} : { [item.count_key]: "" }) })}
                                                    />
                                                    <span className="pf-checkline__icon icon">{item.icon}</span>
                                                    <span className="text-truncate">{t(item.label)}</span>
                                                </label>
                                            ))}
                                        </div>

                                        <div className="row g-3 mt-0">
                                            {PARKING_TYPES.map((item) => (
                                                <div key={item.value} className="col-6">
                                                    {this.input(item.count_key, item.label, {
                                                        numeric: true,
                                                        maxLength: 3,
                                                        unit: "car_unit",
                                                        disabled: !d[item.key],
                                                        placeholder: "optional_value",
                                                    })}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label className="prop-label">{t("available_at")}</label>
                                        <DatePicker type="th" className="prop-field" value={d.available_at} onChange={(value) => this.set({ available_at: value })} />
                                        <div className="pf-hint">{t("available_at_hint")}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* --------------------------------------------- ราคา & เงื่อนไข */}
                    <div className="col-xl-4 col-lg-6">
                        <div className="prop-card prop-in h-100">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("price_and_conditions")}
                                </span>
                            </div>
                            <div className="p-4 d-flex flex-column gap-3">
                                {/* กรอกได้ทั้งสองช่องเสมอ — ค่าเช่าไม่บังคับ เหลือดอกจันเฉพาะราคาขายของประกาศขาย */}
                                <div>{this.unitField("rent_price", "rent", { suffix: "baht_per_month", placeholder: "optional_value", amount: true })}</div>

                                <div>{this.unitField("sale_price", "price", { required: isSaleDeal(d.deals), suffix: "unit_baht", placeholder: "optional_value", amount: true })}</div>

                                <div>{this.unitField("deposit_fee", "deposit", { suffix: "unit_baht", placeholder: "optional_value", amount: true })}</div>

                                {/* ระยะสัญญาเช่า — ตัวเลขกับหน่วยต้องอ่านคู่กัน จึงวางไว้แถวเดียวกัน
                                    เลือกได้ถึง 11 เท่านั้น (12 เดือน = 1 ปี ให้สลับหน่วยเอา)
                                    เลือก 0 = ไม่กำหนดสัญญาขั้นต่ำ ระบบจะล้างหน่วยทิ้งให้ตอนบันทึก */}
                                <div className="row g-2">
                                    <div className="col-6">
                                        {this.select(
                                            "contract_term",
                                            "contract_term",
                                            CONTRACT_TERMS.map((e) => ({ value: e, label: e })),
                                            {
                                                clearable: true,
                                                placeholder: "optional_value",
                                            }
                                        )}
                                    </div>
                                    <div className="col-6">
                                        {this.select(
                                            "contract_unit",
                                            "contract_unit",
                                            CONTRACT_UNITS.map((e) => ({ value: e.value, label: t(e.label) })),
                                            {
                                                disabled: !Number(d.contract_term),
                                            }
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                        <label className="prop-label mb-0">{t("advance_payment")}</label>
                                        <div className="pf-radios">
                                            {/* ไม่ใช้ → บังคับเป็น 0 และล็อกช่องไว้ กลับมาใช้ค่อยตั้งกลับเป็น 1 เดือน */}
                                            <label className={"pf-radio-inline " + (d.advance_use ? "is-on" : "")}>
                                                <input
                                                    type="radio"
                                                    name="advance_use"
                                                    checked={d.advance_use}
                                                    onChange={() => this.set({ advance_use: true, advance_month: Number(d.advance_month) ? d.advance_month : "1" })}
                                                />
                                                {t("use_it")}
                                            </label>
                                            <label className={"pf-radio-inline " + (!d.advance_use ? "is-on" : "")}>
                                                <input type="radio" name="advance_use" checked={!d.advance_use} onChange={() => this.set({ advance_use: false, advance_month: "0" })} />
                                                {t("not_use_it")}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="pf-suffix mt-2">
                                        <input
                                            type="text"
                                            className="prop-field"
                                            disabled={!d.advance_use}
                                            value={d.advance_month}
                                            onChange={(e) => digits(e.target.value) && this.set({ advance_month: e.target.value })}
                                        />
                                        <span className="pf-suffix__unit">{t("unit_months")}</span>
                                    </div>
                                </div>

                                <div>
                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                        <label className="prop-label mb-0">{t("co_agent_fee")}</label>
                                        <div className="pf-radios">
                                            {/* ไม่ติดโค → ล้างสัดส่วนและผู้ติดต่อทิ้ง แล้วล็อกช่องไว้
                                                (ชื่อ/เบอร์ Co-Agent กรอกที่ขั้นตอนที่ 4 หัวข้อข้อมูลการเงิน) */}
                                            <label className={"pf-radio-inline " + (d.co_agent_use ? "is-on" : "")}>
                                                <input type="radio" name="co_agent_use" checked={d.co_agent_use} onChange={() => this.set({ co_agent_use: true })} />
                                                {t("accept_it")}
                                            </label>
                                            <label className={"pf-radio-inline " + (!d.co_agent_use ? "is-on" : "")}>
                                                <input
                                                    type="radio"
                                                    name="co_agent_use"
                                                    checked={!d.co_agent_use}
                                                    onChange={() => this.set({ co_agent_use: false, co_agent_share: "", co_agent_name: "", co_agent_phone: "" })}
                                                />
                                                {t("not_accept_it")}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="pf-suffix mt-2">
                                        <input
                                            type="text"
                                            className="prop-field"
                                            disabled={!d.co_agent_use}
                                            placeholder={d.co_agent_use ? t("optional_value") : t("not_accept_co_agent")}
                                            value={d.co_agent_share}
                                            onChange={(e) => digits(e.target.value) && this.set({ co_agent_share: e.target.value })}
                                        />
                                        <span className="pf-suffix__unit">{t("unit_percent")}</span>
                                    </div>
                                </div>

                                <div>{this.unitField("move_in_payment", "move_in_payment", { suffix: "unit_baht", placeholder: "optional_value", amount: true })}</div>

                                {/* ค่าส่วนกลาง — จำนวนเงินต่อเดือน คู่กับคำตอบว่าค่าเช่าที่ประกาศไว้รวมมาแล้วหรือยัง
                                    (คำถามแรก ๆ ของผู้เช่า ถ้าไม่บอกจะกลายเป็นค่าใช้จ่ายที่รู้ทีหลัง) */}
                                <div>{this.unitField("common_fee_amount", "common_fee", { suffix: "baht_per_month", placeholder: "optional_value", amount: true })}</div>

                                <div>
                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                        <label className="prop-label mb-0">{t("common_fee_included")}</label>
                                        <div className="pf-radios">
                                            <label className={"pf-radio-inline " + (d.common_fee_included ? "is-on" : "")}>
                                                <input
                                                    type="radio"
                                                    name="common_fee_included"
                                                    checked={d.common_fee_included}
                                                    onChange={() => this.set({ common_fee_included: true })}
                                                />
                                                {t("included")}
                                            </label>
                                            <label className={"pf-radio-inline " + (!d.common_fee_included ? "is-on" : "")}>
                                                <input
                                                    type="radio"
                                                    name="common_fee_included"
                                                    checked={!d.common_fee_included}
                                                    onChange={() => this.set({ common_fee_included: false })}
                                                />
                                                {t("not_included")}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                        <label className="prop-label mb-0">{t("special_terms")}</label>
                                        <span className="text-secondary text-12">
                                            {d.special_terms.length} / {MAX_SPECIAL_TERMS}
                                        </span>
                                    </div>
                                    <textarea
                                        className="prop-field mt-2"
                                        rows={3}
                                        maxLength={MAX_SPECIAL_TERMS}
                                        placeholder={t("special_terms_placeholder")}
                                        value={d.special_terms}
                                        onChange={(e) => this.set({ special_terms: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ------------------------------------- สิ่งอำนวยความสะดวก */}
                    <div className="col-xl-4">
                        <div className="prop-card prop-in h-100">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("amenities")}
                                </span>
                                <div className="d-flex align-items-center gap-2">
                                    <span className="text-secondary text-12">
                                        {d.amenities.length} / {AMENITIES.length}
                                    </span>
                                    <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.toggleAllAmenities}>
                                        {t(hasAllAmenities(d.amenities) ? "clear_all" : "select_all")}
                                    </button>
                                </div>
                            </div>
                            <div className="p-4">
                                <div className="pf-section">
                                    <div className="pf-checks">
                                        {AMENITIES.map((item) => {
                                            const on = d.amenities.includes(item.value);
                                            return (
                                                <label key={item.value} className={"pf-checkline " + (on ? "is-on" : "")}>
                                                    <input type="checkbox" checked={on} onChange={() => this.toggleAmenity(item.value)} />
                                                    <span className="pf-checkline__icon icon">{item.icon}</span>
                                                    <span className="text-truncate">{t(item.label)}</span>
                                                </label>
                                            );
                                        })}
                                    </div>
                                    {d.amenities.includes("other") && (
                                        <input
                                            type="text"
                                            className="prop-field mt-2"
                                            placeholder={t("amenity_other_placeholder")}
                                            value={d.amenity_other}
                                            onChange={(e) => this.set({ amenity_other: e.target.value })}
                                        />
                                    )}
                                </div>

                                {/* การตกแต่ง / เฟอร์นิเจอร์ — เลือกได้อย่างละค่าเดียว กดซ้ำที่ค่าเดิม = ล้างเป็น "ยังไม่ระบุ" */}
                                {[
                                    { key: "decoration", label: "decoration", options: DECORATIONS },
                                    { key: "furnished", label: "furnish", options: FURNISH_OPTIONS },
                                ].map((row) => (
                                    <div key={row.key} className="pf-section">
                                        <label className="prop-label">{t(row.label)}</label>
                                        <div className="pf-checks">
                                            {row.options.map((item) => {
                                                const on = d[row.key] === item.value;
                                                return (
                                                    <label key={item.value} className={"pf-checkline " + (on ? "is-on" : "")}>
                                                        <input type="checkbox" checked={on} onChange={() => this.set({ [row.key]: on ? "" : item.value })} />
                                                        <span className="text-truncate">{t(item.label)}</span>
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ))}

                                {/* ส่วนกลางของโครงการ — คนละชุดกับของในห้อง (สระ ฟิตเนส รปภ. ฯลฯ) */}
                                <div className="pf-section">
                                    <label className="prop-label">{t("project_facilities")}</label>
                                    <div className="pf-checks">
                                        {FACILITIES.map((item) => {
                                            const on = d.facilities.includes(item.value);
                                            return (
                                                <label key={item.value} className={"pf-checkline " + (on ? "is-on" : "")}>
                                                    <input type="checkbox" checked={on} onChange={() => this.toggleFacility(item.value)} />
                                                    <span className="pf-checkline__icon icon">{item.icon}</span>
                                                    <span className="text-truncate">{t(item.label)}</span>
                                                </label>
                                            );
                                        })}
                                    </div>
                                    {d.facilities.includes("other") && (
                                        <input
                                            type="text"
                                            className="prop-field mt-2"
                                            placeholder={t("facility_other_placeholder")}
                                            value={d.facility_other}
                                            onChange={(e) => this.set({ facility_other: e.target.value })}
                                        />
                                    )}
                                </div>

                                {/* สัตว์เลี้ยง — ตอบได้แค่อนุญาต/ไม่อนุญาต จึงเป็นตัวเลือกเดียวไม่ใช่ติ๊ก */}
                                <div className="pf-section mb-0">
                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                        <label className="prop-label mb-0">{t("pet")}</label>
                                        <div className="pf-radios">
                                            <label className={"pf-radio-inline " + (d.pet_allowed ? "is-on" : "")}>
                                                <input type="radio" name="pet_allowed" checked={d.pet_allowed} onChange={() => this.set({ pet_allowed: true })} />
                                                {t("pet_allowed")}
                                            </label>
                                            <label className={"pf-radio-inline " + (!d.pet_allowed ? "is-on" : "")}>
                                                <input type="radio" name="pet_allowed" checked={!d.pet_allowed} onChange={() => this.set({ pet_allowed: false })} />
                                                {t("pet_not_allowed")}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row g-3">
                    {/* --------------------------------------------- จุดเด่น / แท็ก */}
                    <div className="col-lg-6">
                        <div className="prop-card prop-in h-100">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("highlights_tags")}
                                </span>
                                <span className="text-secondary text-12">{t("highlights_hint")}</span>
                            </div>
                            <div className="p-4">
                                <div className="pf-picks">
                                    {TAGS.map((tag) => (
                                        <button
                                            key={tag.value}
                                            type="button"
                                            aria-pressed={d.tags.includes(tag.value)}
                                            className={"pf-pick " + (d.tags.includes(tag.value) ? "is-on" : "")}
                                            onClick={() => this.toggleTag(tag.value)}
                                        >
                                            {t(tag.label)}
                                        </button>
                                    ))}
                                    {/* แท็กที่ผู้ใช้พิมพ์เพิ่มเอง (ไม่มีในรายการมาตรฐาน) */}
                                    {d.tags
                                        .filter((value) => !TAGS.some((e) => e.value === value))
                                        .map((value) => (
                                            <button key={value} type="button" className="pf-pick is-on is-custom" onClick={() => this.toggleTag(value)}>
                                                {value}
                                                <span className="icon text-10 ms-2">{"\uf00d"}</span>
                                            </button>
                                        ))}
                                </div>

                                <div className="mt-3">
                                    {tag_open ? (
                                        <div className="pf-taginput">
                                            <input
                                                type="text"
                                                autoFocus
                                                className="prop-field"
                                                placeholder={t("tag_placeholder")}
                                                value={tag_input}
                                                onChange={(e) => this.setState({ tag_input: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") this.AddTag();
                                                    if (e.key === "Escape") this.setState({ tag_input: "", tag_open: false });
                                                }}
                                            />
                                            <button type="button" className="prop-btn prop-btn--sm" onClick={this.AddTag}>
                                                {t("add")}
                                            </button>
                                            <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={() => this.setState({ tag_input: "", tag_open: false })}>
                                                {t("cancel")}
                                            </button>
                                        </div>
                                    ) : (
                                        <button type="button" className="pf-pick pf-pick--add" onClick={() => this.setState({ tag_open: true })}>
                                            <span className="icon text-10 me-2">{"\uf067"}</span>
                                            {t("add_tag")}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ------------------------------------- รายละเอียด (Description) */}
                    <div className="col-lg-6">
                        <div className="prop-card prop-in h-100">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("description_section")}
                                </span>
                                <span className="text-secondary text-12">
                                    {text.length} / 2000 {t("unit_characters")}
                                </span>
                            </div>
                            <div className="p-4">
                                {/* แถบภาษา + ปุ่มผู้ช่วย AI อยู่แถวเดียวกัน (AI เขียนให้เฉพาะภาษาที่เปิดอยู่) */}
                                <div className="pf-tabs">
                                    {DESC_LANGS.map((item) => (
                                        <button
                                            key={item.value}
                                            type="button"
                                            className={"pf-tab " + (desc_lang === item.value ? "is-on" : "")}
                                            onClick={() => this.setState({ desc_lang: item.value })}
                                        >
                                            {t(item.label)}
                                            {!!(d[item.field] || "").trim() && <span className="pf-tab__dot" />}
                                        </button>
                                    ))}
                                    <button type="button" className="pf-ai" title={t("ai_write_hint")} onClick={this.GenerateDescription}>
                                        <span className="icon me-2">{"\uf0d0"}</span>
                                        {t("ai_write")}
                                    </button>
                                </div>

                                <textarea
                                    className="prop-field mt-3"
                                    rows={8}
                                    maxLength={2000}
                                    placeholder={t("description_placeholder")}
                                    value={text}
                                    onChange={(e) => this.set({ [lang.field]: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    /* ============================================= ขั้นที่ 4 : ข้อมูลภายใน */
    renderStepInternal = () => {
        const d = this.state.data;
        const { doc_drop } = this.state;

        return (
            <>
                {/* แถบเตือนว่าทั้งขั้นตอนนี้ไม่ออกหน้าประกาศสาธารณะ */}
                <div className="pf-note prop-in mb-3">
                    <span className="icon">{"\uf071"}</span>
                    <span>{t("internal_warning")}</span>
                </div>

                <div className="row g-3">
                    {/* --------------------------------------------- ข้อมูลเจ้าของ */}
                    <div className="col-xl-4 col-lg-6">
                        <div className="prop-card prop-in h-100">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("owner_info")}
                                </span>
                                <span className="pf-lock text-12">
                                    <span className="icon me-1">{"\uf023"}</span>
                                    {t("internal_only")}
                                </span>
                            </div>
                            <div className="p-4">
                                <div className="d-flex flex-column gap-3">
                                    <div>{this.input("owner_name", "owner_name", { required: true, placeholder: "owner_name_placeholder" })}</div>
                                    <div>{this.input("owner_phone", "owner_phone", { required: true, placeholder: "owner_phone_placeholder" })}</div>
                                    <div>{this.input("owner_line", "owner_line", { placeholder: "owner_line_placeholder" })}</div>
                                    <div>{this.input("owner_facebook", "owner_facebook", { placeholder: "owner_facebook_placeholder" })}</div>
                                    <div>{this.input("owner_email", "owner_email", { placeholder: "owner_email_placeholder" })}</div>
                                </div>

                                <label className="pf-switchrow mt-4">
                                    <span>{t("owner_overseas")}</span>
                                    <span className={"pf-switch " + (d.owner_overseas ? "is-on" : "")}>
                                        <input type="checkbox" checked={d.owner_overseas} onChange={(e) => this.set({ owner_overseas: e.target.checked })} />
                                        <span className="pf-switch__dot" />
                                    </span>
                                </label>
                                {d.owner_overseas && <div className="pf-hint">{t("owner_overseas_hint")}</div>}
                            </div>
                        </div>
                    </div>

                    {/* ---------------------------------------------- ข้อมูลการเงิน */}
                    <div className="col-xl-4 col-lg-6">
                        <div className="prop-card prop-in h-100">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("finance_info")}
                                </span>
                            </div>
                            <div className="p-4">
                                <div className="d-flex flex-column gap-3">
                                    {/* ค่าเช่า/ราคาขาย เป็นฟิลด์เดียวกับขั้นตอนที่ 3 แก้ที่ไหนก็ตรงกัน */}
                                    <div>{this.unitField("rent_per_month", "rent", { suffix: "baht_per_month", placeholder: "optional_value", amount: true })}</div>
                                    <div>{this.unitField("sale_price", "price", { suffix: "unit_baht", placeholder: "optional_value", amount: true })}</div>
                                    <div>{this.unitField("water_fee", "water_fee", { suffix: "unit_baht", placeholder: "optional_value", amount: true })}</div>
                                    <div>{this.unitField("common_fee", "common_fee_month", { suffix: "unit_months", placeholder: "optional_value" })}</div>
                                    {/* Co-Agent — เป็นตัวเลือกเดียวกับขั้นตอนที่ 3 แก้ที่ไหนก็ตรงกัน
                                        ไม่ติดโค = ไม่ต้องถามสัดส่วนและผู้ติดต่อ จึงซ่อนทั้งชุดไปเลย */}
                                    <div>
                                        <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                            <label className="prop-label mb-0">{t("co_agent_split")}</label>
                                            <div className="pf-radios">
                                                <label className={"pf-radio-inline " + (d.co_agent_use ? "is-on" : "")}>
                                                    <input type="radio" name="co_agent_use_finance" checked={d.co_agent_use} onChange={() => this.set({ co_agent_use: true })} />
                                                    {t("co_agent_yes")}
                                                </label>
                                                <label className={"pf-radio-inline " + (!d.co_agent_use ? "is-on" : "")}>
                                                    <input
                                                        type="radio"
                                                        name="co_agent_use_finance"
                                                        checked={!d.co_agent_use}
                                                        onChange={() => this.set({ co_agent_use: false, co_agent_share: "", co_agent_name: "", co_agent_phone: "" })}
                                                    />
                                                    {t("co_agent_no")}
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {d.co_agent_use && (
                                        <>
                                            <div>{this.unitField("", "co_agent_share", { suffix: "unit_percent", placeholder: "optional_value" })}</div>
                                            <div>{this.input("co_agent_name", "co_agent_name", { placeholder: "co_agent_name_placeholder" })}</div>
                                            <div>{this.input("co_agent_phone", "co_agent_phone", { placeholder: "owner_phone_placeholder" })}</div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* --------------------------- สถานะทรัพย์ + โน้ตภายใน + เอกสาร */}
                    <div className="col-xl-4">
                        {/* สถานะทรัพย์ — แก้ได้ทั้งตอนสร้างและตอนแก้ไข
                            เปลี่ยนเป็นขายแล้ว/ปล่อยเช่าแล้ว = ระบบปิดดีลและออกรหัสดีลให้เอง */}
                        <div className="prop-card prop-in mb-3">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("property_status")}
                                </span>
                            </div>
                            <div className="p-4 d-flex flex-column gap-2">
                                {PROPERTY_STATUS.map((item) => {
                                    const on = d.status === item.value;
                                    return (
                                        <label
                                            key={item.value}
                                            className={"pf-status " + (on ? "is-on" : "")}
                                            style={on ? { borderColor: item.dot, background: item.tint } : undefined}
                                        >
                                            <input
                                                type="radio"
                                                name="asset_status"
                                                className="d-none"
                                                checked={on}
                                                onChange={() => this.set({ status: item.value })}
                                            />
                                            <span className="pf-status__dot" style={{ backgroundColor: item.dot }} />
                                            <span className="flex-grow-1">
                                                <span className="pf-status__title" style={on ? { color: item.color } : undefined}>
                                                    {t(item.label)}
                                                </span>
                                                <span className="pf-status__desc">{t(item.desc)}</span>
                                            </span>
                                            <span
                                                className="pf-status__mark icon"
                                                style={on ? { background: item.dot, borderColor: item.dot, color: "#fff" } : undefined}
                                            >
                                                {""}
                                            </span>
                                        </label>
                                    );
                                })}
                                <div className="pf-hint">{t("property_status_hint")}</div>
                            </div>
                        </div>

                        <div className="prop-card prop-in mb-3">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("internal_note")}
                                </span>
                                <span className="pf-lock text-12">
                                    <span className="icon me-1">{"\uf023"}</span>
                                    {t("internal_only")}
                                </span>
                            </div>
                            <div className="p-4">
                                <textarea
                                    className="prop-field pf-notes"
                                    rows={6}
                                    placeholder={t("internal_note_placeholder")}
                                    value={d.internal_note}
                                    onChange={(e) => this.set({ internal_note: e.target.value })}
                                    onKeyDown={this.NoteBullet}
                                />
                                <div className="pf-hint">{t("internal_note_hint")}</div>
                            </div>
                        </div>

                        <div className="prop-card prop-in">
                            <div className="prop-card__head">
                                <span className="prop-title text-16">
                                    <span className="prop-title__dot" />
                                    {t("documents")}
                                    <span className="pf-head-note">
                                        ({t("admin_only")} · {t("optional")})
                                    </span>
                                </span>
                                <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.PickDocuments}>
                                    <span className="icon text-12">{"\uf0c6"}</span>
                                    {t("attach_file")}
                                </button>
                            </div>
                            <div className="p-4">
                                <div
                                    className={"pf-doclist " + (doc_drop ? "is-over" : "")}
                                    onDragOver={(e) => {
                                        if (!hasFiles(e)) return;
                                        e.preventDefault();
                                        if (!doc_drop) this.setState({ doc_drop: true });
                                    }}
                                    onDragLeave={(e) => {
                                        if (e.currentTarget.contains(e.relatedTarget)) return;
                                        this.setState({ doc_drop: false });
                                    }}
                                    onDrop={(e) => {
                                        if (!hasFiles(e)) return;
                                        e.preventDefault();
                                        this.setState({ doc_drop: false });
                                        this.AddDocuments(e.dataTransfer.files);
                                    }}
                                >
                                    {d.documents.map((file) => (
                                        <div key={file.uid} className="pf-doc">
                                            <span className="pf-doc__icon icon">{file.type === "image" ? "\uf1c5" : "\uf1c1"}</span>
                                            <span className="pf-doc__name text-truncate" title={file.name}>
                                                {file.name}
                                            </span>
                                            <span className="pf-doc__size">{file.size}</span>
                                            <button type="button" className="pf-doc__x icon" title={t("delete_file")} onClick={() => this.RemoveDocument(file)}>
                                                {"\uf00d"}
                                            </button>
                                        </div>
                                    ))}

                                    {!d.documents.length && (
                                        <div className="pf-doc pf-doc--empty">
                                            <span className="pf-doc__icon icon">{"\uf15b"}</span>
                                            <span className="text-12 text-secondary">{t("no_document_yet")}</span>
                                        </div>
                                    )}
                                </div>
                                <div className="pf-hint">{t("document_accept")}</div>

                                <input
                                    ref={this.doc_input}
                                    type="file"
                                    accept=".jpg,.jpeg,.png,.pdf,image/*,application/pdf"
                                    multiple
                                    className="d-none"
                                    onChange={(e) => {
                                        this.AddDocuments(e.target.files);
                                        e.target.value = "";
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    /* ======================================== ขั้นที่ 5 : Preview & Publish */
    // รูปที่กำลังโชว์ในกรอบพรีวิว — ยังไม่ได้เลือกก็ใช้รูปปกเป็นค่าเริ่มต้น
    previewPhoto = () => {
        const { photos, cover } = this.state.data;
        return photos.find((e) => e.uid === this.state.preview_photo) || photos.find((e) => e.uid === cover) || photos[0];
    };

    // ข้อความสรุปใต้ตัวเลือกการเผยแพร่ — บอกให้ชัดว่ากดปุ่มแล้วจะเกิดอะไรขึ้น
    publishNote = () => {
        const d = this.state.data;
        if (d.publish_mode !== "schedule") return t(publishMode(d).note);
        if (!d.publish_at) return t("verify_publish_at");
        return `${t("publish_note_schedule")} ${d.publish_at} ${t("time_at")} ${d.publish_time} ${t("hour_unit")}`;
    };

    renderStepPreview = () => {
        const d = this.state.data;
        const { preview_device, preview_lang, summary_tab } = this.state;
        const meta = this.category();
        const photo = this.previewPhoto();
        const checklist = this.checklist();
        const done = checklist.filter((e) => e.ok).length;
        const percent = Math.round((done / checklist.length) * 100);
        // ผู้ดูแลคือคนที่สร้างประกาศ ระบบกำหนดให้ตอนบันทึก (ฟอร์มไม่มีช่องให้เลือก)
        const admin = { name: d.admin_name };
        const address = [d.soi, d.subdistrict, d.district, d.province, d.postcode].filter(Boolean).join(" ");
        const mode = publishMode(d);
        // แท็บภาษาในพรีวิว — โชว์เฉพาะภาษาที่เขียนรายละเอียดไว้แล้ว
        const langs = DESC_LANGS.filter((e) => (d[e.field] || "").trim());
        const lang = langs.find((e) => e.value === preview_lang) || langs[0];
        const direction = DIRECTIONS.find((e) => e.value === d.direction);

        // key ใช้เฉพาะตอนเรียกในลูป (ที่จอดรถ) — ที่เหลือเขียนตรง ๆ ไม่ต้องมี
        const spec = (icon, text, key) => (
            <span className="prop-spec" key={key}>
                <span className="icon">{icon}</span>
                {text}
            </span>
        );

        const kv = (label, value) => (
            <div className="pf-kv">
                <span className="pf-kv__k">{t(label)}</span>
                <span className="pf-kv__v">{value || "-"}</span>
            </div>
        );

        return (
            <div className="row g-3">
                {/* ------------------------------------------------ ตัวอย่างประกาศ */}
                <div className="col-xxl-8 col-xl-7">
                    <div className="prop-card prop-in pf-pvcard mb-3">
                        <div className="prop-card__head">
                            <span className="prop-title text-16">
                                <span className="prop-title__dot" />
                                {t("listing_preview")}
                                <span className="pf-head-note">({t("preview_hint")})</span>
                            </span>
                            {/* สลับดูการแสดงผลบนเดสก์ท็อป / มือถือ */}
                            <div className="pf-device">
                                {[
                                    { value: "desktop", label: "preview_desktop", icon: "" },
                                    { value: "mobile", label: "preview_mobile", icon: "" },
                                ].map((item) => (
                                    <button
                                        key={item.value}
                                        type="button"
                                        className={"pf-device__btn " + (preview_device === item.value ? "is-on" : "")}
                                        onClick={() => this.setState({ preview_device: item.value })}
                                    >
                                        <span className="icon text-12">{item.icon}</span>
                                        <span className="d-none d-sm-inline">{t(item.label)}</span>
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="pf-stage p-4">
                            <div className={"pf-pv " + (preview_device === "mobile" ? "pf-pv--mobile" : "")}>
                                {/* รูปปก + ป้ายประเภทประกาศ + ราคา */}
                                <div className="pf-hero" style={photo?.url ? undefined : { background: photo?.grad || meta.grad }}>
                                    {photo?.url ? (
                                        <img src={photo.url} alt={photo.name} className="pf-hero__img" />
                                    ) : (
                                        <span className="pf-hero__ghost icon">{meta.icon}</span>
                                    )}

                                    <div className="pf-hero__top">
                                        {DEALS.filter((e) => (d.deals || []).includes(e.value)).map((e) => (
                                            <span key={e.value} className={"pf-hero__deal is-" + e.value}>
                                                {t(e.label)}
                                            </span>
                                        ))}
                                        {!!d.code && <span className="pf-hero__code">{d.code}</span>}
                                    </div>

                                    <div className="pf-hero__bottom">
                                        <div className="pf-hero__prices">
                                            {isRentDeal(d.deals) && (
                                                <span className="pf-hero__price">
                                                    {money(d.rent)} <small>{t("baht_per_month")}</small>
                                                </span>
                                            )}
                                            {isSaleDeal(d.deals) && (
                                                <span className="pf-hero__price pf-hero__price--sale">
                                                    {money(d.price)} <small>{t("unit_baht")}</small>
                                                </span>
                                            )}
                                        </div>
                                        <span className="pf-hero__count">
                                            <span className="icon text-10">{""}</span>
                                            {d.photos.length}
                                            {!!d.video_url && <span className="icon text-10 ms-2">{""}</span>}
                                            {!!d.floor_plans.length && <span className="icon text-10 ms-2">{""}</span>}
                                        </span>
                                    </div>
                                </div>

                                {/* แถบรูปย่อ — กดเพื่อสลับรูปที่โชว์ด้านบน */}
                                {d.photos.length > 1 && (
                                    <div className="pf-strip">
                                        {d.photos.slice(0, 7).map((item) => (
                                            <button
                                                key={item.uid}
                                                type="button"
                                                title={item.name}
                                                className={"pf-strip__item " + (item.uid === photo?.uid ? "is-on" : "")}
                                                style={item.url ? undefined : { background: item.grad }}
                                                onClick={() => this.setState({ preview_photo: item.uid })}
                                            >
                                                {!!item.url && <img src={item.url} alt={item.name} />}
                                                {item.uid === d.cover && <span className="pf-strip__star icon">{""}</span>}
                                            </button>
                                        ))}
                                        {d.photos.length > 7 && <span className="pf-strip__more">+{d.photos.length - 7}</span>}
                                    </div>
                                )}

                                <div className="pf-pv__body">
                                    <div className="d-flex align-items-start justify-content-between gap-2 flex-wrap">
                                        <span className="pf-pv__title">{listingTitle(d, this.typeName())}</span>
                                        <span className="prop-tag">{this.typeName()}</span>
                                    </div>

                                    <div className="prop-addr mt-2">
                                        <span className="icon text-10">{""}</span>
                                        <span>{address || "-"}</span>
                                    </div>

                                    <div className="prop-specs mt-3">
                                        {!!Number(d.bedroom) && spec("", `${d.bedroom} ${t("bed_unit")}`)}
                                        {!!Number(d.bathroom) && spec("", `${d.bathroom} ${t("bath_unit")}`)}
                                        {!!Number(d.area) && spec("", `${d.area} ${t("sqm")}`)}
                                        {!!Number(d.land_area) && spec("", `${d.land_area} ${t("sqw")}`)}
                                        {!!Number(d.floor) && spec("", `${t("floor_label")} ${d.floor}`)}
                                        {/* ระบุจำนวนคันไว้ให้ต่อท้ายชื่อประเภท ไม่ได้ระบุก็โชว์แค่ประเภทที่จอดได้ */}
                                        {parkingTypes(d).map((item) => {
                                            const count = parkingCount(d, item);
                                            return spec(item.icon, count ? `${t(item.label)} ${count} ${t("car_unit")}` : t(item.label), item.value);
                                        })}
                                        {!!direction && spec("", t(direction.label))}
                                    </div>

                                    {/* รายละเอียด — สลับดูได้เฉพาะภาษาที่กรอกไว้ */}
                                    <div className="pf-pv__sec">
                                        <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
                                            <span className="pf-pv__label">{t("description_section")}</span>
                                            {langs.length > 1 && (
                                                <div className="pf-langpills">
                                                    {langs.map((item) => (
                                                        <button
                                                            key={item.value}
                                                            type="button"
                                                            className={"pf-langpill " + (lang?.value === item.value ? "is-on" : "")}
                                                            onClick={() => this.setState({ preview_lang: item.value })}
                                                        >
                                                            {t(item.label)}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        {lang ? <div className="pf-pv__desc">{d[lang.field]}</div> : <div className="pf-pv__empty">{t("no_description_yet")}</div>}
                                    </div>

                                    {!!d.amenities.length && (
                                        <div className="pf-pv__sec">
                                            <span className="pf-pv__label">{t("amenities")}</span>
                                            <div className="pf-tags mt-2">
                                                {d.amenities.map((value) => {
                                                    const item = AMENITIES.find((e) => e.value === value);
                                                    return (
                                                        <span key={value} className="pf-tag">
                                                            <span className="icon text-12">{item?.icon}</span>
                                                            {value === "other" && d.amenity_other ? d.amenity_other : t(item?.label || value)}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}

                                    {/* ส่วนกลางของโครงการ — ชุดคนละชุดกับของในห้อง จึงแยกบล็อกให้ชัด */}
                                    {!!d.facilities.length && (
                                        <div className="pf-pv__sec">
                                            <span className="pf-pv__label">{t("project_facilities")}</span>
                                            <div className="pf-tags mt-2">
                                                {d.facilities.map((value) => {
                                                    const item = FACILITIES.find((e) => e.value === value);
                                                    return (
                                                        <span key={value} className="pf-tag">
                                                            <span className="icon text-12">{item?.icon}</span>
                                                            {value === "other" && d.facility_other ? d.facility_other : t(item?.label || value)}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}

                                    {/* การตกแต่ง / เฟอร์นิเจอร์ / สัตว์เลี้ยง — สัตว์เลี้ยงโชว์เสมอเพราะตอบไปแล้วทุกใบ */}
                                    <div className="pf-pv__sec">
                                        <div className="pf-tags">
                                            {!!decorationMeta(d.decoration) && <span className="pf-tag">{t(decorationMeta(d.decoration).label)}</span>}
                                            {!!furnishMeta(d.furnished) && <span className="pf-tag">{t(furnishMeta(d.furnished).label)}</span>}
                                            <span className="pf-tag">
                                                {t("pet")} : {t(d.pet_allowed ? "pet_allowed" : "pet_not_allowed")}
                                            </span>
                                        </div>
                                    </div>

                                    {!!d.tags.length && (
                                        <div className="pf-pv__sec">
                                            <span className="pf-pv__label">{t("highlights_tags")}</span>
                                            <div className="pf-tags mt-2">
                                                {d.tags.map((value) => {
                                                    const item = TAGS.find((e) => e.value === value);
                                                    return (
                                                        <span key={value} className="pf-tag pf-tag--hl">
                                                            <span className="icon text-10">{""}</span>
                                                            {item ? t(item.label) : value}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}

                                    {!!d.keywords.length && (
                                        <div className="pf-pv__keys">
                                            {d.keywords.map((value) => (
                                                <span key={value} className="pf-pv__key">
                                                    #{value}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* สรุปข้อมูล — สลับดูข้อมูลที่ขึ้นหน้าเว็บ / ข้อมูลภายใน */}
                    <div className="prop-card prop-in">
                        <div className="prop-card__head">
                            <span className="prop-title text-16">
                                <span className="prop-title__dot" />
                                {t("listing_summary")}
                            </span>
                            <div className="pf-tabs pf-tabs--sm">
                                {[
                                    { value: "listing", label: "summary_listing" },
                                    { value: "internal", label: "summary_internal" },
                                ].map((item) => (
                                    <button
                                        key={item.value}
                                        type="button"
                                        className={"pf-tab " + (summary_tab === item.value ? "is-on" : "")}
                                        onClick={() => this.setState({ summary_tab: item.value })}
                                    >
                                        {t(item.label)}
                                    </button>
                                ))}
                            </div>
                        </div>
                        {/* การ์ดกว้างเต็มคอลัมน์ — แบ่งรายการเป็น 2 คอลัมน์เมื่อจอกว้างพอ */}
                        <div className="px-4 py-2 pf-kvgrid">
                            {summary_tab === "internal" ? (
                                <>
                                    {kv("owner_name", d.owner_name)}
                                    {kv("owner_phone", d.owner_phone)}
                                    {kv("owner_line", d.owner_line)}
                                    {kv("owner_overseas", t(d.owner_overseas ? "answer_yes" : "answer_no"))}
                                    {kv("co_agent_split", !d.co_agent_use ? t("co_agent_no") : d.co_agent_share ? `${d.co_agent_share}%` : "-")}
                                    {/* ติดโคกับใคร ต้องเห็นตอนตรวจก่อนเผยแพร่ด้วย ไม่งั้นข้อมูลติดต่อจะตกหล่น */}
                                    {d.co_agent_use && kv("co_agent_name", [d.co_agent_name, d.co_agent_phone].filter(Boolean).join(" · "))}
                                    {kv("documents", `${d.documents.length} ${t("unit_files")}`)}
                                    {kv("property_status", t(statusMeta(d.status).label))}
                                    {kv("owner_admin", admin?.name)}
                                </>
                            ) : (
                                <>
                                    {kv(
                                        "listing_type",
                                        DEALS.filter((e) => (d.deals || []).includes(e.value))
                                            .map((e) => t(e.label))
                                            .join(" + ")
                                    )}
                                    {kv("property_type", this.typeName())}
                                    {kv("project", d.project)}
                                    {kv("property_code", d.code)}
                                    {kv("location", [d.subdistrict, d.district, d.province].filter(Boolean).join(" · "))}
                                    {isLandType(d.type)
                                        ? kv("land_area_sqw", d.land_area && `${d.land_area} ${t("sqw")}`)
                                        : kv("usable_area_sqm", d.area && `${d.area} ${t("sqm")}`)}
                                    {/* บ้านแนวราบโชว์ที่ดินกับจำนวนชั้นเพิ่ม เฉพาะตอนที่กรอกไว้ */}
                                    {isHouseType(d.type) && !!d.land_area && kv("land_area_sqw", `${d.land_area} ${t("sqw")}`)}
                                    {isHouseType(d.type) && !!d.floor_count && kv("floor_count", `${d.floor_count} ${t("floor_label")}`)}
                                    {isRentDeal(d.deals) && kv("rent_price", `${money(d.rent)} ${t("baht_per_month")}`)}
                                    {/* ระยะสัญญาโชว์เฉพาะประกาศเช่า และเฉพาะตอนที่ระบุไว้ (0 = ไม่กำหนดขั้นต่ำ) */}
                                    {isRentDeal(d.deals) && !!Number(d.contract_term) &&
                                        kv("contract_term", `${d.contract_term} ${t(contractUnitMeta(d.contract_unit).label)}`)}
                                    {isSaleDeal(d.deals) && kv("sale_price", `${money(d.price)} ${t("unit_baht")}`)}
                                    {/* ค่าส่วนกลาง / เงื่อนไขพิเศษ โชว์เฉพาะตอนที่กรอกไว้ ไม่งั้นจะได้แถวเปล่า */}
                                    {!!d.common_fee &&
                                        kv(
                                            "common_fee_amount",
                                            `${money(d.common_fee)} ${t("baht_per_month")}${d.common_fee_included ? ` · ${t("detail_cost_included_in_rent")}` : ""}`
                                        )}
                                    {!!d.special_terms.trim() && kv("special_terms", d.special_terms)}
                                    {kv("photos", `${d.photos.length} ${t("unit_photos")}`)}
                                    {kv("floor_plan", `${d.floor_plans.length} ${t("unit_files")}`)}
                                    {kv("video_or_link", d.video_url)}
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* ------------------------------- ความครบถ้วน / การเผยแพร่ */}
                <div className="col-xxl-4 col-xl-5">
                    <div className="prop-card prop-in mb-3">
                        <div className="prop-card__head">
                            <span className="prop-title text-16">
                                <span className="prop-title__dot" />
                                {t("completeness")}
                            </span>
                            <span className={"pf-state " + (percent === 100 ? "is-ok" : "")}>
                                <span className="icon text-10">{percent === 100 ? "" : ""}</span>
                                {t(percent === 100 ? "ready_to_publish" : "data_incomplete")}
                            </span>
                        </div>
                        <div className="p-4">
                            <div className="d-flex align-items-center gap-4 mb-3">
                                {/* วงแหวนความคืบหน้า */}
                                <div className={"pf-ring " + (percent === 100 ? "is-ok" : "")}>
                                    <svg viewBox="0 0 80 80">
                                        <circle className="pf-ring__bg" cx="40" cy="40" r="34" />
                                        <circle
                                            className="pf-ring__bar"
                                            cx="40"
                                            cy="40"
                                            r="34"
                                            strokeDasharray={RING_LENGTH}
                                            strokeDashoffset={RING_LENGTH * (1 - percent / 100)}
                                        />
                                    </svg>
                                    <span className="pf-ring__num">{percent}%</span>
                                </div>
                                <div>
                                    <div className="pf-ring__done">
                                        {done}
                                        <span>/{checklist.length}</span>
                                    </div>
                                    <div className="text-secondary text-12">{t("checklist_hint")}</div>
                                </div>
                            </div>

                            <div className="pf-checklist">
                                {checklist.map((item) => (
                                    <div key={item.key} className={"pf-checkitem " + (item.ok ? "is-ok" : "")}>
                                        <span className="pf-checkitem__mark icon">{item.ok ? "" : ""}</span>
                                        <span className="flex-grow-1">{t(item.key)}</span>
                                        {item.ok ? (
                                            <span className="pf-checkitem__step">{item.step}</span>
                                        ) : (
                                            <button type="button" className="prop-link" onClick={() => this.goStep(item.step)}>
                                                {t("go_fix")}
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="prop-card prop-in">
                        <div className="prop-card__head">
                            <span className="prop-title text-16">
                                <span className="prop-title__dot" />
                                {t("publish_options")}
                            </span>
                        </div>
                        <div className="p-4 d-flex flex-column gap-2">
                            {PUBLISH_MODES.map((item) => (
                                <label key={item.value} className={"pf-pub " + (d.publish_mode === item.value ? "is-on" : "")}>
                                    <input
                                        type="radio"
                                        name="publish_mode"
                                        className="d-none"
                                        checked={d.publish_mode === item.value}
                                        onChange={() => this.set({ publish_mode: item.value })}
                                    />
                                    <span className="pf-pub__icon icon">{item.icon}</span>
                                    <span className="flex-grow-1">
                                        <span className="pf-pub__title">{t(item.title)}</span>
                                        <span className="pf-pub__desc">{t(item.desc)}</span>
                                    </span>
                                    <span className="pf-pub__mark icon">{""}</span>
                                </label>
                            ))}

                            {d.publish_mode === "schedule" && (
                                <div className="row g-2 mt-1">
                                    <div className="col-7">
                                        <label className="prop-label">{t("publish_date")}</label>
                                        <DatePicker type="th" className="prop-field" value={d.publish_at} onChange={(value) => this.set({ publish_at: value })} />
                                    </div>
                                    <div className="col-5">
                                        <label className="prop-label">{t("publish_time")}</label>
                                        <Select
                                            className="prop-field prop-select"
                                            default={false}
                                            placeholder={t("please_select")}
                                            value={d.publish_time}
                                            options={PUBLISH_TIMES.map((e) => ({ value: e, label: `${e} ${t("hour_unit")}` }))}
                                            onChange={(value) => this.set({ publish_time: value })}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className={"pf-pubnote " + (mode.value === "draft" ? "is-mute" : "")}>
                                <span className="icon text-12">{mode.icon}</span>
                                <span>{this.publishNote()}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderStep = () => {
        switch (this.state.step) {
            case 1:
                return this.renderStepBasic();
            case 2:
                return this.renderStepMedia();
            case 3:
                return this.renderStepDetails();
            case 4:
                return this.renderStepInternal();
            default:
                return this.renderStepPreview();
        }
    };

    render() {
        const { step } = this.state;
        const last = step === STEPS.length;

        return (
            <div className="w-100 min-vh-100 prop-page">
                <NavbarAdmin />
                <div className="body p-4">
                    {/* หัวข้อหน้า */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
                        <div className="d-flex align-items-center gap-3">
                            <button type="button" className="prop-iconbtn icon" title={t("back")} aria-label={t("back")} onClick={this.Cancel}>
                                {""}
                            </button>
                            <div>
                                <h3 className="fw-bold mb-1 text-dark">{t(this.is_create ? "add_property" : "edit_property")}</h3>
                                <div className="text-secondary text-14">
                                    {t("step")} {step} {t("of")} {STEPS.length} · {t(STEPS[step - 1].label)}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {/* ขั้นสุดท้ายมีตัวเลือก "บันทึกเป็นแบบร่าง" อยู่แล้ว จึงไม่ต้องมีปุ่มซ้ำ */}
                            {!last && (
                                <button type="button" className="prop-btn prop-btn--ghost" onClick={this.SaveDraft}>
                                    <span className="icon text-14">{""}</span>
                                    {t("save_draft")}
                                </button>
                            )}
                            {!this.is_create && (
                                <button type="button" className="prop-btn prop-btn--ghost" onClick={() => this.JumpStep(STEPS.length)}>
                                    <span className="icon text-14">{"\uf06e"}</span>
                                    {t("preview")}
                                </button>
                            )}
                        </div>
                    </div>

                    {this.renderSteps()}
                    {this.renderStep()}

                    {/* แถบปุ่มด้านล่าง */}
                    <div className="pf-footer">
                        <button type="button" className="prop-btn prop-btn--ghost" onClick={() => (step === 1 ? this.Cancel() : this.goStep(step - 1))}>
                            <span className="icon text-12">{""}</span>
                            {step === 1 ? t("cancel") : t("previous")}
                        </button>

                        <div className="d-flex align-items-center gap-4">
                            <span className="text-secondary text-12 d-none d-md-inline">
                                {t("step")} {step} / {STEPS.length}
                            </span>
                            {last ? (
                                <button type="button" className="prop-btn" onClick={this.Submit}>
                                    <span className="icon text-14">{publishMode(this.state.data).icon}</span>
                                    {t(publishMode(this.state.data).action)}
                                </button>
                            ) : (
                                <button type="button" className="prop-btn" onClick={this.Next}>
                                    {t("next")}
                                    <span className="icon text-12">{""}</span>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PropertyCreate);
